<template>
    <div>
        <div class="spinner_hold_new" v-if="loading">
            <!-- <div class="spin">
                <i class="fa fa-spinner fa-spin"></i>
                <span>{{loadingMessage}} ...</span>
            </div> -->
        </div>
        <div class="error_hold" v-if="error">
            <h5>Error fetching data!</h5>
            <p>{{errorMessage}}</p>
        </div>
        <div class="error_hold" v-if="noservicemsg">
            <h5>Error fetching data!</h5>
            <p>Services cannot be loaded</p>
        </div>
        <!-- <div class="loading" v-if="loading">
            {{loadingMessage}}
        </div>
        <div class="error" v-if="error">
            {{errorMessage}}
        </div> -->
        <div v-if="!error && !loading">
            <!-- Personalised header -->
            <app-personalised-header />
            <!-- Personalised header ends -->

            <!-- Page header -->
            <section>
                <div class="centric-hold-80">
                    <div class="wrapp-rt2">
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><h2 class="main-head1">Booking Appointment at {{locationName}}</h2></div>
                            <!-- <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><p class="sub-head1 pull-right">Manage your Bookings? <span><a href="#">Click here</a></span></p></div> -->
                        </div>
                    </div>
                </div>
            </section>
            <!-- Page header ends -->
    
            <!-- Stepper -->
            <section>
                <div class="centric-hold-80">
                    <div class="wrapp-rt2">
                        <div class="booking-steps">
                            <div class="row">
                               
                                <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                    <div class="date-time-hold">
                                        <div :class="[{'completed-stage': (showStep == 1 && !step1Valid)},
                                        {'completed-stage-success': (step1Valid)},
                                        {'completed-stage-deactive': (showStep != 1 && !step1Valid)}]">
                                        <i class="material-icons" v-if="step1Valid">check</i>
                                        <i v-else style="font-style: normal;">1</i>
                                        </div>
                                        Select a Service
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 no-pad">
                                    <div class="date-time-hold">
                                        <div :class="[{'completed-stage': (showStep == 2 && !step2Valid)},
                                        {'completed-stage-success': (step2Valid)},
                                        {'completed-stage-deactive': (showStep != 2 && !step2Valid)}]">
                                        <i class="material-icons" v-if="step2Valid">check</i>
                                        <i v-else style="font-style: normal;">2</i>
                                        </div> 
                                        Choose Date and Time
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 no-pad">
                                    <div class="date-time-hold">
                                        <div :class="[{'completed-stage': (showStep == 3 && !step3Valid)},
                                        {'completed-stage-success': (step3Valid)},
                                        {'completed-stage-deactive': (showStep != 3 && !step3Valid)}]">
                                        <i class="material-icons" v-if="step3Valid">check</i>
                                        <i v-else style="font-style: normal;">3</i>
                                        </div>
                                        Personal Details
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 no-pad">
                                    <div class="date-time-hold no-border">
                                        <div :class="[{'completed-stage': (showStep == 4 && !step4Valid)},
                                        {'completed-stage-success': (step4Valid)},
                                        {'completed-stage-deactive': (showStep != 4 && !step4Valid)}]">
                                        <i class="material-icons" v-if="step4Valid">check</i>
                                        <i v-else style="font-style: normal;">4</i>
                                        </div> 
                                        Complete your Booking
                                    </div>
                                </div>
                            </div>
                        </div>			
                    </div>
                </div>
            </section>
            <!-- Stepper ends -->

            <!-- validation messages --> 
            <section v-if="onPageValidationErrors.length > 0">
                <div class="centric-hold-80">
                    <div class="wrapp-rt2">
                        <div class="row mt-50">
                            <div class="error_hold"> 
                                <h5>Please correct the following errors!</h5>
                                <p v-for="item in onPageValidationErrors" :key="item">
                                    {{item}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section v-if="loadingData">
                <div class="centric-hold-80">
                    <div class="wrapp-rt2">
                        <div class="row mt-50">
                            <div class="spinner_hold">
                                <div class="spin">
                                    <i class="fa fa-spinner fa-spin"></i>
                                    <span>Loading, please wait ...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section v-if="errorLoadingData.length > 0">
                <div class="centric-hold-80">
                    <div class="wrapp-rt2">
                        <div class="row mt-50">
                            <div class="error_hold"> 
                                <h5>Please correct the following errors!</h5>
                                <p v-for="item in errorLoadingData" :key="item">
                                    {{item}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- validation message end -->

            <!-- Select Service Step -->
            <section v-if="showStep === 1">
                <div class="centric-hold-80">
                    <div class="wrapp-rt2">
                        <div class="row mt-50 justify-content-center">
                            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12" v-for="item in serviceGroups" :key="item.id" v-if="services[item.name]">
                                <div class="select-time-slat" >
                                    <h6>{{item.name}}</h6>
                                    <div class="select-time-hold">
                                        <div class="Y-T-slot-one" v-for="(itemserv,index) in services[item.name]" :key="itemserv.id" v-if="itemserv.id != ''" @click="selectService(itemserv)">
                                            <div>
                                                <p style="width:100%;">
                                                    {{itemserv.name}}  <br/>
                                                    <span v-if="!(item.name.includes('Email')||tenantId=='94be5b4c-9ddc-4bd1-8c6c-07768ebd1908')"><i class="material-icons y-t-time">access_time</i> 
                                                    Duration: {{itemserv.duration}} mins
                                                    </span>
                                                    <span v-if="!(item.name.includes('Email'))" style="padding: 0 0 0 15px; float:right;">
                                                        <span v-if="showPriceData(itemserv.cost_type)" class="d-flex align-items-center">
                                                            Price: 
                                                            <span v-html="currencylocation" class="p-0"></span>
                                                            {{formatPrice(itemserv.service_cost)}}
                                                        </span>
                                                        <span v-else>
                                                            <span :id="'tootltipTxt'+index" class="tooltip-special"><i class="fa fa-star-o"></i> <em>Price available on request</em></span>
                                                            <div :id="'tootltipArr'+index" class="tooltip-special-arrow" style="top:60%;"></div>
                                                            <i class="info-custom-icon" v-on:mouseover="addCss(index)" v-on:mouseleave="removeCss(index)" aria-hidden="true">i</i>
                                                                
                                                        </span>
                                                    </span>
                                                    <span v-else>
                                                        <span v-if="showPriceData(itemserv.cost_type)" class="d-flex align-items-center">
                                                            Price: 
                                                            <span v-html="currencylocation" class="p-0"></span>
                                                            {{formatPrice(itemserv.service_cost)}}
                                                        </span>
                                                        <span v-else>
                                                            <span :id="'tootltipTxt'+index" class="tooltip-special"><i class="fa fa-star-o"></i> <em>Price available on request</em></span>
                                                            <div :id="'tootltipArr'+index" class="tooltip-special-arrow" style="top:60%;"></div>
                                                            <i class="info-custom-icon" v-on:mouseover="addCss(index)" v-on:mouseleave="removeCss(index)" aria-hidden="true">i</i>
                                                                
                                                        </span>
                                                    </span>
                                                    <!-- <span v-else style="padding: 0 0 0 15px;">
                                                        Price: 
                                                        <i class="fa fa-usd fa-1" aria-hidden="true"></i> 
                                                        {{formatPrice(itemserv.service_cost_usd)}} 
                                                    </span> -->
                                                </p>  
                                                <div class="checkbox pull-right">
                                                    <!-- <input type="checkbox" :value="itemserv.id" id="itemserv.id" v-model="selectedServiceId"> -->
                                                    <!-- <div v-if="step1Valid || step2Valid || step3Valid || step4Valid" class="select-btn-hold"><button type="button" class="btn btn-primary btn-next" @click="validateStep1">Next</button></div> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div><!-- end  select-time-hold -->
                                </div><!-- end  select-time-slat --> 
                            </div>                       
                        </div>
                        <div v-if="showServiceCondition === 'y'" style="padding:20px 0 0 0;text-align:center;">* This price is subject to change</div>                    
                        <!-- <p v-if="priceonreqFlag" style="text-align:center;margin-top:10px;">
                            <i class="fa fa-asterisk" style="font-size: 0.8em;color:#868688;" aria-hidden="true"></i>
                            Price available on request
                        </p> -->
                    </div>                    
                </div>
                
                <div class="centric-hold-80" v-if="step1Valid || step2Valid || step3Valid || step4Valid">
                    <div class="wrapp-rt2 pad-20">
                        <button type="button" class="btn btn-primary btn-back" :disabled="true">Back</button>
                        <button type="button" class="btn btn-primary btn-next pull-right" @click="validateStep1">Next</button>
                    </div>
                </div>
            </section>
            <!-- Select Service Step ends -->

            <!-- time slot starts -->
            <section v-if="showStep === 2">
                <!--Select a time slot--> 
                <div class="centric-hold-80">
                    <div class="wrapp-rt2">
                        <div class="display-daytime-hold pull-left">
                            <h4>Today {{new Date() | moment("MMM DD, YYYY")}}</h4>
                        </div>
                        <div class="display-daytime-hold pull-right">
                            <!-- <div class="date-fbward" v-if="datePage > 1" @click="prevDateSet()"><i class="material-icons">keyboard_arrow_left</i></div> -->
                            <span class="pull-calender-right date-icon-holder" style="position: relative;">
                                <p class="selectDate">Select Date</p>
                                <input type="text" id="startflatpickr"  class="date select_validate" v-model="displayedStartDate" data-mindate="" placeholder="Start date" style="text-align: right !important; background: inherit !important; border: 0;">
                                <span class="date-icon in-form"></span>
                                <!-- <i class="material-icons" style="top: 4px !important; right: 0px; position: absolute;">calendar_today</i> -->
                            </span>
                            <!-- <span class="date-icon"></span> -->
                            <!-- <div class="date-fbward" @click="nextDateSet()"><i class="material-icons">keyboard_arrow_right</i></div> -->
                        </div>
                    </div>
                </div>
                <div class="centric-hold-80">
                    <div class="wrapp-rt2">
                        <div class="row">
                            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12" v-for="item in availableSlots" :key="item.date">
                                <div class="select-time-slat" >
                                    <h5>{{ item.date | moment(" Do MMMM, YYYY (dddd)")}}</h5>
                                    <div class="select-time-hold" v-if="item.slots.length > 0">
                                        <div class="Y-T-slot" v-for="slot in item.slots" :key="slot.split('|')[0]" @click="selectSlot(slot)">
                                            <span><i class="material-icons">wb_sunny</i></span>
                                            <p>{{slot.split("|")[0] | moment("hh:mm A") }} - {{addDuration(slot.split("|")[0])}}</p>  
                                            <div class="checkbox pull-right" v-if="!(slot.split('|')[1] == 'U' || slotIsBefore(slot.split('|')[0]))">
                                                <!-- <input type="checkbox" :value="slot.split('|')[0]" id="slot.split('|')[0]" v-model="selectedSlotId"> -->
                                            </div>
                                            <div class="checkbox pull-right"  v-if="slot.split('|')[1] == 'U' || slotIsBefore(slot.split('|')[0])">
                                                <i class="material-icons c-l-grey">block</i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="select-time-hold" v-if="item.slots.length == 0">
                                        <div class="Y-T-slot blocked">
                                            <span><i class="material-icons">event_busy</i></span>
                                            <p>Sorry, no slots are available!</p>  
                                        </div>
                                    </div><!-- end  select-time-hold -->
                                </div><!-- end  select-time-slat -->
                            </div>                        
                        </div>
                    </div>
                </div>              
                <div class="centric-hold-80">
                    <div class="wrapp-rt2 pad-20">
                        <button v-if="step1Valid || step2Valid || step3Valid || step4Valid" type="button" class="btn btn-primary btn-next pull-right" @click="validateStep2">Next</button>
                        <button type="button" class="btn btn-primary btn-back" @click="goBack(1)">Back</button>
                    </div>
                </div>
                <!--// End - Select a time slot--> 
            </section>
            <!-- time slot ends -->
	
            <section class="mid-spacer" v-if="showStep === 3">
                <div class="wrapp-mid-50">
                <div class="form-mid-hold">
                    <h2>Provide your Personal Details</h2>
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <form>
                                <div class="form-group">
                                    <input name="Name" v-model="personName"  class="form-control" placeholder="Your Full Name*" type="text">
                                    <span style="color:red" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
                                </div>
                                <div class="form-group">
                                    <input name="Email" v-model="personEmail"  class="form-control" placeholder="Your Email*" type="text">
                                    <span style="color:red" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
                                </div>
                                <div class="form-group">
                                    <!-- country codes (ISO 3166) and Dial codes. -->
                                    <select name="countryCode" v-model="personMobileCC"  class="form-control" placeholder="Mobile Number Country Code*">
                                        <option data-countryCode="IN" value="91">India (+91)</option>
                                        <option data-countryCode="GB" value="44">UK (+44)</option>
                                        <option data-countryCode="US" value="1">USA (+1)</option>
                                        <optgroup label="Other countries">
                                            <option data-countryCode="DZ" value="213">Algeria (+213)</option>
                                            <option data-countryCode="AD" value="376">Andorra (+376)</option>
                                            <option data-countryCode="AO" value="244">Angola (+244)</option>
                                            <option data-countryCode="AI" value="1264">Anguilla (+1264)</option>
                                            <option data-countryCode="AG" value="1268">Antigua &amp; Barbuda (+1268)</option>
                                            <option data-countryCode="AR" value="54">Argentina (+54)</option>
                                            <option data-countryCode="AM" value="374">Armenia (+374)</option>
                                            <option data-countryCode="AW" value="297">Aruba (+297)</option>
                                            <option data-countryCode="AU" value="61">Australia (+61)</option>
                                            <option data-countryCode="AT" value="43">Austria (+43)</option>
                                            <option data-countryCode="AZ" value="994">Azerbaijan (+994)</option>
                                            <option data-countryCode="BS" value="1242">Bahamas (+1242)</option>
                                            <option data-countryCode="BH" value="973">Bahrain (+973)</option>
                                            <option data-countryCode="BD" value="880">Bangladesh (+880)</option>
                                            <option data-countryCode="BB" value="1246">Barbados (+1246)</option>
                                            <option data-countryCode="BY" value="375">Belarus (+375)</option>
                                            <option data-countryCode="BE" value="32">Belgium (+32)</option>
                                            <option data-countryCode="BZ" value="501">Belize (+501)</option>
                                            <option data-countryCode="BJ" value="229">Benin (+229)</option>
                                            <option data-countryCode="BM" value="1441">Bermuda (+1441)</option>
                                            <option data-countryCode="BT" value="975">Bhutan (+975)</option>
                                            <option data-countryCode="BO" value="591">Bolivia (+591)</option>
                                            <option data-countryCode="BA" value="387">Bosnia Herzegovina (+387)</option>
                                            <option data-countryCode="BW" value="267">Botswana (+267)</option>
                                            <option data-countryCode="BR" value="55">Brazil (+55)</option>
                                            <option data-countryCode="BN" value="673">Brunei (+673)</option>
                                            <option data-countryCode="BG" value="359">Bulgaria (+359)</option>
                                            <option data-countryCode="BF" value="226">Burkina Faso (+226)</option>
                                            <option data-countryCode="BI" value="257">Burundi (+257)</option>
                                            <option data-countryCode="KH" value="855">Cambodia (+855)</option>
                                            <option data-countryCode="CM" value="237">Cameroon (+237)</option>
                                            <option data-countryCode="CA" value="1">Canada (+1)</option>
                                            <option data-countryCode="CV" value="238">Cape Verde Islands (+238)</option>
                                            <option data-countryCode="KY" value="1345">Cayman Islands (+1345)</option>
                                            <option data-countryCode="CF" value="236">Central African Republic (+236)</option>
                                            <option data-countryCode="CL" value="56">Chile (+56)</option>
                                            <option data-countryCode="CN" value="86">China (+86)</option>
                                            <option data-countryCode="CO" value="57">Colombia (+57)</option>
                                            <option data-countryCode="KM" value="269">Comoros (+269)</option>
                                            <option data-countryCode="CG" value="242">Congo (+242)</option>
                                            <option data-countryCode="CK" value="682">Cook Islands (+682)</option>
                                            <option data-countryCode="CR" value="506">Costa Rica (+506)</option>
                                            <option data-countryCode="HR" value="385">Croatia (+385)</option>
                                            <option data-countryCode="CU" value="53">Cuba (+53)</option>
                                            <option data-countryCode="CY" value="90392">Cyprus North (+90392)</option>
                                            <option data-countryCode="CY" value="357">Cyprus South (+357)</option>
                                            <option data-countryCode="CZ" value="42">Czech Republic (+42)</option>
                                            <option data-countryCode="DK" value="45">Denmark (+45)</option>
                                            <option data-countryCode="DJ" value="253">Djibouti (+253)</option>
                                            <option data-countryCode="DM" value="1809">Dominica (+1809)</option>
                                            <option data-countryCode="DO" value="1809">Dominican Republic (+1809)</option>
                                            <option data-countryCode="EC" value="593">Ecuador (+593)</option>
                                            <option data-countryCode="EG" value="20">Egypt (+20)</option>
                                            <option data-countryCode="SV" value="503">El Salvador (+503)</option>
                                            <option data-countryCode="GQ" value="240">Equatorial Guinea (+240)</option>
                                            <option data-countryCode="ER" value="291">Eritrea (+291)</option>
                                            <option data-countryCode="EE" value="372">Estonia (+372)</option>
                                            <option data-countryCode="ET" value="251">Ethiopia (+251)</option>
                                            <option data-countryCode="FK" value="500">Falkland Islands (+500)</option>
                                            <option data-countryCode="FO" value="298">Faroe Islands (+298)</option>
                                            <option data-countryCode="FJ" value="679">Fiji (+679)</option>
                                            <option data-countryCode="FI" value="358">Finland (+358)</option>
                                            <option data-countryCode="FR" value="33">France (+33)</option>
                                            <option data-countryCode="GF" value="594">French Guiana (+594)</option>
                                            <option data-countryCode="PF" value="689">French Polynesia (+689)</option>
                                            <option data-countryCode="GA" value="241">Gabon (+241)</option>
                                            <option data-countryCode="GM" value="220">Gambia (+220)</option>
                                            <option data-countryCode="GE" value="7880">Georgia (+7880)</option>
                                            <option data-countryCode="DE" value="49">Germany (+49)</option>
                                            <option data-countryCode="GH" value="233">Ghana (+233)</option>
                                            <option data-countryCode="GI" value="350">Gibraltar (+350)</option>
                                            <option data-countryCode="GR" value="30">Greece (+30)</option>
                                            <option data-countryCode="GL" value="299">Greenland (+299)</option>
                                            <option data-countryCode="GD" value="1473">Grenada (+1473)</option>
                                            <option data-countryCode="GP" value="590">Guadeloupe (+590)</option>
                                            <option data-countryCode="GU" value="671">Guam (+671)</option>
                                            <option data-countryCode="GT" value="502">Guatemala (+502)</option>
                                            <option data-countryCode="GN" value="224">Guinea (+224)</option>
                                            <option data-countryCode="GW" value="245">Guinea - Bissau (+245)</option>
                                            <option data-countryCode="GY" value="592">Guyana (+592)</option>
                                            <option data-countryCode="HT" value="509">Haiti (+509)</option>
                                            <option data-countryCode="HN" value="504">Honduras (+504)</option>
                                            <option data-countryCode="HK" value="852">Hong Kong (+852)</option>
                                            <option data-countryCode="HU" value="36">Hungary (+36)</option>
                                            <option data-countryCode="IS" value="354">Iceland (+354)</option>                                    
                                            <option data-countryCode="ID" value="62">Indonesia (+62)</option>
                                            <option data-countryCode="IR" value="98">Iran (+98)</option>
                                            <option data-countryCode="IQ" value="964">Iraq (+964)</option>
                                            <option data-countryCode="IE" value="353">Ireland (+353)</option>
                                            <option data-countryCode="IL" value="972">Israel (+972)</option>
                                            <option data-countryCode="IT" value="39">Italy (+39)</option>
                                            <option data-countryCode="JM" value="1876">Jamaica (+1876)</option>
                                            <option data-countryCode="JP" value="81">Japan (+81)</option>
                                            <option data-countryCode="JO" value="962">Jordan (+962)</option>
                                            <option data-countryCode="KZ" value="7">Kazakhstan (+7)</option>
                                            <option data-countryCode="KE" value="254">Kenya (+254)</option>
                                            <option data-countryCode="KI" value="686">Kiribati (+686)</option>
                                            <option data-countryCode="KP" value="850">Korea North (+850)</option>
                                            <option data-countryCode="KR" value="82">Korea South (+82)</option>
                                            <option data-countryCode="KW" value="965">Kuwait (+965)</option>
                                            <option data-countryCode="KG" value="996">Kyrgyzstan (+996)</option>
                                            <option data-countryCode="LA" value="856">Laos (+856)</option>
                                            <option data-countryCode="LV" value="371">Latvia (+371)</option>
                                            <option data-countryCode="LB" value="961">Lebanon (+961)</option>
                                            <option data-countryCode="LS" value="266">Lesotho (+266)</option>
                                            <option data-countryCode="LR" value="231">Liberia (+231)</option>
                                            <option data-countryCode="LY" value="218">Libya (+218)</option>
                                            <option data-countryCode="LI" value="417">Liechtenstein (+417)</option>
                                            <option data-countryCode="LT" value="370">Lithuania (+370)</option>
                                            <option data-countryCode="LU" value="352">Luxembourg (+352)</option>
                                            <option data-countryCode="MO" value="853">Macao (+853)</option>
                                            <option data-countryCode="MK" value="389">Macedonia (+389)</option>
                                            <option data-countryCode="MG" value="261">Madagascar (+261)</option>
                                            <option data-countryCode="MW" value="265">Malawi (+265)</option>
                                            <option data-countryCode="MY" value="60">Malaysia (+60)</option>
                                            <option data-countryCode="MV" value="960">Maldives (+960)</option>
                                            <option data-countryCode="ML" value="223">Mali (+223)</option>
                                            <option data-countryCode="MT" value="356">Malta (+356)</option>
                                            <option data-countryCode="MH" value="692">Marshall Islands (+692)</option>
                                            <option data-countryCode="MQ" value="596">Martinique (+596)</option>
                                            <option data-countryCode="MR" value="222">Mauritania (+222)</option>
                                            <option data-countryCode="YT" value="269">Mayotte (+269)</option>
                                            <option data-countryCode="MX" value="52">Mexico (+52)</option>
                                            <option data-countryCode="FM" value="691">Micronesia (+691)</option>
                                            <option data-countryCode="MD" value="373">Moldova (+373)</option>
                                            <option data-countryCode="MC" value="377">Monaco (+377)</option>
                                            <option data-countryCode="MN" value="976">Mongolia (+976)</option>
                                            <option data-countryCode="MS" value="1664">Montserrat (+1664)</option>
                                            <option data-countryCode="MA" value="212">Morocco (+212)</option>
                                            <option data-countryCode="MZ" value="258">Mozambique (+258)</option>
                                            <option data-countryCode="MN" value="95">Myanmar (+95)</option>
                                            <option data-countryCode="NA" value="264">Namibia (+264)</option>
                                            <option data-countryCode="NR" value="674">Nauru (+674)</option>
                                            <option data-countryCode="NP" value="977">Nepal (+977)</option>
                                            <option data-countryCode="NL" value="31">Netherlands (+31)</option>
                                            <option data-countryCode="NC" value="687">New Caledonia (+687)</option>
                                            <option data-countryCode="NZ" value="64">New Zealand (+64)</option>
                                            <option data-countryCode="NI" value="505">Nicaragua (+505)</option>
                                            <option data-countryCode="NE" value="227">Niger (+227)</option>
                                            <option data-countryCode="NG" value="234">Nigeria (+234)</option>
                                            <option data-countryCode="NU" value="683">Niue (+683)</option>
                                            <option data-countryCode="NF" value="672">Norfolk Islands (+672)</option>
                                            <option data-countryCode="NP" value="670">Northern Marianas (+670)</option>
                                            <option data-countryCode="NO" value="47">Norway (+47)</option>
                                            <option data-countryCode="OM" value="968">Oman (+968)</option>
                                            <option data-countryCode="PW" value="680">Palau (+680)</option>
                                            <option data-countryCode="PA" value="507">Panama (+507)</option>
                                            <option data-countryCode="PG" value="675">Papua New Guinea (+675)</option>
                                            <option data-countryCode="PY" value="595">Paraguay (+595)</option>
                                            <option data-countryCode="PE" value="51">Peru (+51)</option>
                                            <option data-countryCode="PH" value="63">Philippines (+63)</option>
                                            <option data-countryCode="PL" value="48">Poland (+48)</option>
                                            <option data-countryCode="PT" value="351">Portugal (+351)</option>
                                            <option data-countryCode="PR" value="1787">Puerto Rico (+1787)</option>
                                            <option data-countryCode="QA" value="974">Qatar (+974)</option>
                                            <option data-countryCode="RE" value="262">Reunion (+262)</option>
                                            <option data-countryCode="RO" value="40">Romania (+40)</option>
                                            <option data-countryCode="RU" value="7">Russia (+7)</option>
                                            <option data-countryCode="RW" value="250">Rwanda (+250)</option>
                                            <option data-countryCode="SM" value="378">San Marino (+378)</option>
                                            <option data-countryCode="ST" value="239">Sao Tome &amp; Principe (+239)</option>
                                            <option data-countryCode="SA" value="966">Saudi Arabia (+966)</option>
                                            <option data-countryCode="SN" value="221">Senegal (+221)</option>
                                            <option data-countryCode="CS" value="381">Serbia (+381)</option>
                                            <option data-countryCode="SC" value="248">Seychelles (+248)</option>
                                            <option data-countryCode="SL" value="232">Sierra Leone (+232)</option>
                                            <option data-countryCode="SG" value="65">Singapore (+65)</option>
                                            <option data-countryCode="SK" value="421">Slovak Republic (+421)</option>
                                            <option data-countryCode="SI" value="386">Slovenia (+386)</option>
                                            <option data-countryCode="SB" value="677">Solomon Islands (+677)</option>
                                            <option data-countryCode="SO" value="252">Somalia (+252)</option>
                                            <option data-countryCode="ZA" value="27">South Africa (+27)</option>
                                            <option data-countryCode="ES" value="34">Spain (+34)</option>
                                            <option data-countryCode="LK" value="94">Sri Lanka (+94)</option>
                                            <option data-countryCode="SH" value="290">St. Helena (+290)</option>
                                            <option data-countryCode="KN" value="1869">St. Kitts (+1869)</option>
                                            <option data-countryCode="SC" value="1758">St. Lucia (+1758)</option>
                                            <option data-countryCode="SD" value="249">Sudan (+249)</option>
                                            <option data-countryCode="SR" value="597">Suriname (+597)</option>
                                            <option data-countryCode="SZ" value="268">Swaziland (+268)</option>
                                            <option data-countryCode="SE" value="46">Sweden (+46)</option>
                                            <option data-countryCode="CH" value="41">Switzerland (+41)</option>
                                            <option data-countryCode="SI" value="963">Syria (+963)</option>
                                            <option data-countryCode="TW" value="886">Taiwan (+886)</option>
                                            <option data-countryCode="TJ" value="7">Tajikstan (+7)</option>
                                            <option data-countryCode="TH" value="66">Thailand (+66)</option>
                                            <option data-countryCode="TG" value="228">Togo (+228)</option>
                                            <option data-countryCode="TO" value="676">Tonga (+676)</option>
                                            <option data-countryCode="TT" value="1868">Trinidad &amp; Tobago (+1868)</option>
                                            <option data-countryCode="TN" value="216">Tunisia (+216)</option>
                                            <option data-countryCode="TR" value="90">Turkey (+90)</option>
                                            <option data-countryCode="TM" value="7">Turkmenistan (+7)</option>
                                            <option data-countryCode="TM" value="993">Turkmenistan (+993)</option>
                                            <option data-countryCode="TC" value="1649">Turks &amp; Caicos Islands (+1649)</option>
                                            <option data-countryCode="TV" value="688">Tuvalu (+688)</option>
                                            <option data-countryCode="UG" value="256">Uganda (+256)</option>
                                            <!-- <option data-countryCode="GB" value="44">UK (+44)</option> -->
                                            <option data-countryCode="UA" value="380">Ukraine (+380)</option>
                                            <option data-countryCode="AE" value="971">United Arab Emirates (+971)</option>
                                            <option data-countryCode="UY" value="598">Uruguay (+598)</option>
                                            <!-- <option data-countryCode="US" value="1">USA (+1)</option> -->
                                            <option data-countryCode="UZ" value="7">Uzbekistan (+7)</option>
                                            <option data-countryCode="VU" value="678">Vanuatu (+678)</option>
                                            <option data-countryCode="VA" value="379">Vatican City (+379)</option>
                                            <option data-countryCode="VE" value="58">Venezuela (+58)</option>
                                            <option data-countryCode="VN" value="84">Vietnam (+84)</option>
                                            <option data-countryCode="VG" value="84">Virgin Islands - British (+1284)</option>
                                            <option data-countryCode="VI" value="84">Virgin Islands - US (+1340)</option>
                                            <option data-countryCode="WF" value="681">Wallis &amp; Futuna (+681)</option>
                                            <option data-countryCode="YE" value="969">Yemen (North)(+969)</option>
                                            <option data-countryCode="YE" value="967">Yemen (South)(+967)</option>
                                            <option data-countryCode="ZM" value="260">Zambia (+260)</option>
                                            <option data-countryCode="ZW" value="263">Zimbabwe (+263)</option>
                                        </optgroup>
                                    </select>
                                    <span style="color:red" v-show="errors.has('countryCode')">{{ errors.first('countryCode') }}</span>
                                </div>
                                <div class="form-group">
                                    <input name="Mobile" v-model="personMobile" class="form-control" placeholder="Mobile (without the Country Code)*" type="text">
                                    <span style="color:red" v-show="errors.has('Mobile')">{{ errors.first('Mobile') }}</span>
                                </div>
                                <div class="form-group">
                                    <!-- Relationship -->
                                    <select name="relationship" v-model="relationshipWithPatient"  class="form-control" placeholder="Your relationship with the Patient*">
                                        <option value="Self">I am the Patient</option>
                                        <option value="Son">Booking for my Son</option>
                                        <option value="Daughter">Booking for my Daughter</option>
                                        <option value="Mother">Booking for my Mother</option>
                                        <option value="Father">Booking for my Father</option>
                                        <option value="Husband">Booking for my Husband</option>
                                        <option value="Wife">Booking for my Wife</option>
                                        <option value="Brother">Booking for my Brother</option>
                                        <option value="Sister">Booking for my Sister</option>
                                        <option value="Friend">Booking for a Friend</option>
                                    </select>
                                    <span style="color:red" v-show="errors.has('relationship')">{{ errors.first('relationship') }}</span>
                                </div>
                                <div class="form-group" v-if="relationshipWithPatient != 'Self'">
                                    <!-- Name of the Patient -->
                                    <input name="patientName" v-model="nameOfPatient"  class="form-control" placeholder="Full Name of the Patient*" type="text">
                                    <span style="color:red" v-show="errors.has('patientName')">{{ errors.first('patientName') }}</span>
                                </div>
                                <div class="form-group">
                                    <!-- Gender of the Patient -->
                                    <select name="gender" v-model="genderOfPatient"  class="form-control" placeholder="Patient's Gender*">
                                        <option value="">Please select the Patient's Gender</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                        <option value="Other">Other</option>
                                    </select>
                                    <span style="color:red" v-show="errors.has('gender')">{{ errors.first('gender') }}</span>
                                </div>
                                <div class="form-group" v-if="selectedService.booking_options == env_bvr&&(!this.selectedService.group_name.includes('Email'))">
                                    <textarea maxlength="500" style="width:100%; height:100px;" name="Name" v-model="preferredScheduleNotes"  class="form-control" placeholder="Your preferred date/time and location" ></textarea>
                                    <span style="color:red" v-show="errors.has('preferredScheduleNotes')">{{ errors.first('preferredScheduleNotes') }}</span>
                                </div>	
                                <div class="form-group">
                                    <label
                      data-toggle="tooltip"
                      data-placement="top"
                      title=""
                      class="customcheck mart-10"
                    >
                    <input
                        type="checkbox"
                        v-model="patientConsent"
                      />
                      <span class="checkmark"></span>
                      I consent to Genamet collecting my data to provide services in accordance with the 
                      <a href="javascript:void(0)" @click="termsNConditionsPopup()"
                        >Privacy Policy</a
                      >
                      
                    </label>
                     <span style="color:red" v-show="errors.has('patientConsent')">{{ errors.first('patientConsent') }}</span>
                                    </div>			
                            </form>
                        </div>
                    </div>
                </div>
                </div>

                <div class="wrapp-mid-50" v-if="selectedService.booking_options == env_bd">
                    <div class="wrapp-rt2 pad-20">
                        <button type="button" class="btn btn-primary btn-next pull-right" @click="validateStep3">Next</button>
                        <button type="button" class="btn btn-primary btn-back rt-8" @click="goBack(2)">Back</button>
                        <button type="button" class="btn btn-primary btn-back rt-8" @click="clear">Clear</button>
                    </div>
                </div>
                <div class="wrapp-mid-50" v-if="selectedService.booking_options == env_bvr">
                    <div class="wrapp-rt2 pad-20">
                        <button type="button" class="btn btn-primary btn-next pull-right" @click="validateStep3">Next</button>
                        <button type="button" class="btn btn-primary btn-back rt-8" @click="goBack(1)">Back</button>
                        <button type="button" class="btn btn-primary btn-back rt-8" @click="clear">Clear</button>
                    </div>
                </div>
            </section>
            <!-- personal details ends -->

            <!-- Complete booking starts -->	
            <section class="mid-spacer" >
                <div class="centric-hold-80 mt-50" v-if="showStep === 4">
                    <div class="wrapp-rt2" v-if="selectedService.booking_options == env_bd">
                        <div class="row" v-if="selectedService.booking_options == env_bd">
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><p class="text-style-md">You are about to book an appointment with <span>{{providerTitle}} {{providerFirstName}} {{providerLastName}}</span>. Appointment details and the location map are displayed below.
                                Click the pencil icon next to the information displayed if you wish to change any detail. Else, click the Book button to create an appointment.</p>
                                <div class="row services-box-hold">
                                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs12 service-edit-hold service-bdr-right services-bdr-bottom"><p>Service <br/><span>{{selectedService.name}}</span><br/>
                                    <!-- <span v-if="browser_country == 'IN'"> -->
                                        <span v-if="showPriceData(this.selectedService.cost_type)" class="d-flex align-items-center">
                                            Price:
                                            <span v-html="currencylocation" class="p-0"></span>
                                            <!-- <i :class="'fa fa-'+currencylocation+' fa-1'" aria-hidden="true"></i>  -->
                                            {{this.selectedService.service_cost}}
                                        </span>
                                        <span v-else>
                                            <i class="fa fa-info-circle fa-lg" aria-hidden="true"></i>
                                            Price available on request
                                        </span>
                                    <!-- </span> -->
                                    <!-- <span v-else>Price: <i class="fa fa-usd fa-1" aria-hidden="true"></i> {{this.selectedService.service_cost_usd}}</span> -->
                                    </p> <div class="edit-booking"><i class="material-icons" @click="goBack(1)">edit</i></div>
                                </div>
                                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs12 service-edit-hold services-bdr-bottom"><p>Date of Appointment<br/><span>{{selectedSlot | moment("Do MMM, YYYY")}}</span></p><div class="edit-booking"><i class="material-icons" @click="goBack(2)">edit</i></div></div>
                                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs12 service-edit-hold service-bdr-right"><p>Time <br/><span>{{selectedSlot | moment("ddd, hh:mm A")}}</span></p><div class="edit-booking"><i class="material-icons"  @click="goBack(2)">edit</i></div></div>
                                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs12 service-edit-hold "><p>Your Details<br/><span>
                                        {{personName}}<br/>
                                        {{personEmail}}<br/>
                                        +{{personMobileCC}}-{{personMobile}}</span></p><div class="edit-booking" @click="goBack(3)"><i class="material-icons" >edit</i></div>
                                    </div>
                                </div>

                            </div>

                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="map-location-hold" v-html="mapUrlEmbedded"></div></div>
                        </div>
                    </div>
                    <div v-if="selectedService.booking_options == env_bvr">
                        <div class="row" v-if="selectedService.booking_options == env_bvr">
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" style="margin:auto;"><p class="text-style-md">You are about to request an appointment with <span>{{providerTitle}} {{providerFirstName}} {{providerLastName}}</span>. Details of your request are displayed below. Click the pencil icon next to the information displayed if you wish to change any detail. Else, click the Submit Request button to send your request.</p>
                                <div class="row services-box-hold">
                                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs12 service-edit-hold service-bdr-right services-bdr-bottom"><p>Service <br/><span>{{selectedService.name}}</span><br/>
                                    <span v-if="browser_country == 'IN'">Price: <span v-html="currencylocation"></span> {{this.selectedService.service_cost}}</span>
                                    <span v-else>Price: <i class="fa fa-usd fa-1" aria-hidden="true"></i> {{this.selectedService.service_cost_usd}}</span></p> <div class="edit-booking"><i class="material-icons" @click="goBack(1)">edit</i></div></div>
                                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs12 service-edit-hold services-bdr-bottom"><p>Your Details<br/><span>
                                    {{personName}}<br/>
                                    {{personEmail}}<br/>
                                    +{{personMobileCC}}-{{personMobile}}</span></p><div class="edit-booking" @click="goBack(3)"><i class="material-icons" >edit</i></div></div>
                                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs12 service-edit-hold"><p>Requested Schedule<br/><span>{{truncateText(preferredScheduleNotes, 50)}}</span></p><div class="edit-booking"><i class="material-icons" @click="goBack(3)">edit</i></div></div>    
                                </div>
                            </div>
                        </div>
                    </div>

                <div id="env_bd_div" class="wrapp-rt2 pad-20" v-if="selectedService.booking_options == env_bd">
                    <button v-if="this.selectedService.payment_preference==env_pay_later && !showpaybutton" @click="bookNow(0)" type="button" class="btn btn-primary btn-next pull-right">Book Now</button>
                    <button v-if="this.selectedService.payment_preference==env_pay_now && !showpaybutton" @click="bookNow(1)" type="button" class="btn btn-primary btn-next pull-right">Pay & Book</button>
                    <button style="margin: 0 0 0 25px;" v-if="this.selectedService.payment_preference==env_pay_any && !showpaybutton" @click="bookNow(1)" type="button" class="btn btn-primary btn-next pull-right">Pay & Book</button>
                    <button v-if="this.selectedService.payment_preference==env_pay_any && !showpaybutton" @click="bookNow(0)" type="button" class="btn btn-primary btn-next pull-right">Book Now, Pay Later</button>
                    <button type="button" @click="goBack(3)" class="btn btn-primary btn-back">Back</button>
                    <button v-if="this.selectedService.payment_preference==env_pay_any && showpaybutton" @click="bookNow(0)" type="button" class="btn btn-primary btn-next pull-right">Book Now, Pay Later</button>
                    <button id="rzp-button1" @click="onRazorPayBtnClick(1)" style="margin: 0 25px 0 25px;" v-if="showpaybutton" class="btn btn-primary btn-next pull-right razorpay-payment-button">Pay & Book</button>
                </div>

                <div class="wrapp-rt2 pad-20" v-if="selectedService.booking_options == env_bvr">
                    <button v-if="this.selectedService.payment_preference==env_pay_later && !showpaybutton" @click="bookNow(0)" type="button" class="btn btn-primary btn-next pull-right">Request Now</button>
                    <button v-if="this.selectedService.payment_preference==env_pay_now && !showpaybutton" @click="bookNow(1)" type="button" class="btn btn-primary btn-next pull-right">Pay & Request</button>
                    <button style="margin: 0 0 0 25px;" v-if="this.selectedService.payment_preference==env_pay_any && !showpaybutton" @click="bookNow(1)" type="button" class="btn btn-primary btn-next pull-right">Pay & Request</button>
                    <button v-if="this.selectedService.payment_preference==env_pay_any && !showpaybutton" @click="bookNow(0)" type="button" class="btn btn-primary btn-next pull-right">Request Now, Pay Later</button>
                    <button type="button" @click="goBack(3)" class="btn btn-primary btn-back">Back</button>
                    <button v-if="this.selectedService.payment_preference==env_pay_any && showpaybutton" @click="bookNow(0)" type="button" class="btn btn-primary btn-next pull-right">Request Now, Pay Later</button>
                    <button id="rzp-button1" @click="onRazorPayBtnClick(1)" style="margin: 0 25px 0 25px;" v-if="showpaybutton" class="btn btn-primary btn-next pull-right razorpay-payment-button">Pay & Request</button>
                </div>

                </div>
            </section>
            <!-- Complete booking ends -->	

            <!-- Razorpay Popup Start-->
                <!-- <div id="razorpaysection" v-if="showpaybutton">
                    <button id="rzp-button1">Pay</button>
                </div> -->
            <!--Razorpay Popup End-->
        </div>
         <Consent
      ref="confirmcomp"
      :showmodal="showCnfrmPopUp"
      @cancelAction="
        showCnfrmPopUp = false;
        confrmPopUpResponse = false;
      "
      @confirmAction="
        showCnfrmPopUp = false;
        confrmPopUpResponse = true;
      "
    >
    </Consent>
    </div>
</template>

<script>
import PersonalisedHeader from "@/views/header/personalised-header.vue"
import Consent from "@/views/home/Consentform.vue";
import Stepper from "@/views/booking/stepper.vue"
import {mapGetters} from 'vuex';
import moment, { ISO_8601 } from 'moment'
import tz from 'moment-timezone'
import axios from 'axios'
import localforage from 'localforage'
import memoryDriver from 'localforage-memoryStorageDriver'
import { setup } from 'axios-cache-adapter'
import flatpickr from 'flatpickr';
import 'flatpickr/dist/themes/material_blue.css';
//import Razorpay from 'razorpay'


var fltDPckr1 = null, fltDPckr2=null;


export default {
    name: "BookingPage",
    data () {
        return {
            showStep: 1,
            browser_country: "IN",
            showServiceCondition: "",
            exchangeRate: "69.00",
            serviceGroups: [],
            services: [],
            selectedServiceId: [],
            selectedService: [],
            selectedSlot: "",
            selectedSlotId: [],
            displayedStartDate: "",
            displayedEndDate: "",
            date: "",
            noservicemsg:false,
            env_bvr: process.env.VUE_APP_BOOKING_OPTIONS_BVR,
            env_bd: process.env.VUE_APP_BOOKING_OPTIONS_BD,
            env_pay_later: process.env.VUE_APP_PAYMENT_PREFERENCE_PAY_LATER,
            env_pay_now: process.env.VUE_APP_PAYMENT_PREFERENCE_PAY_NOW,
            env_pay_any: process.env.VUE_APP_PAYMENT_PREFERENCE_ANY,
            minDate: "",
            availableSlots: [],
            datePage: 1,
            step1Valid: false,
            step2Valid: false,
            step3Valid: false,
            step4Valid: false,
            personName: "",
            personEmail: "",
            personMobile: "",
            personMobileCC: "91",
            relationshipWithPatient: "Self",
            genderOfPatient: "",
            nameOfPatient: "",
            preferredScheduleNotes: "",
            patientConsent:true,
            bookingData: {
                "customer_details": {
                    "name": "",
                    "email": "",
                    "mobile": "",
                    "country_code": "",
                    "relationship": ""
                },
                "patient_details": {
                    "name": "",
                    "email": "",
                    "mobile": "",
                    "country_code": "",
                    "relationship": ""
                },
                "from": "",
                "to": "",
                "provider": {
                    "first_name": "",
                    "last_name": "",
                    "unique_id": "",
                    "color_code": ""
                },
                "facility": {
                    "location_name": "",
                    "unique_id": ""
                },
                "service_details": {
                    "name": "",
                    "code": "",
                    "duration": "",
                    "pre_service_buffer_time": "",
                    "post_service_buffer_time": "",
                    "unique_id": ""
                },
                "status": {
                    "name": process.env.VUE_APP_APPOINTMENT_STATUS_NAME_DEFAULT,
                    "unique_id": process.env.VUE_APP_APPOINTMENT_STATUS_ID_DEFAULT
                },
                "recurring_types": process.env.VUE_APP_RECURRING_TYPES_DEFAULT,
                "source": process.env.VUE_APP_APPOINTMENT_SOURCE_DEFAULT,
                "client_time_zone": this.$store.getters.clientTz 
            },
            showCnfrmPopUp:false,
            locationbasedcurrency:[
  {
    "currency": "Albania Lek",
    "abbreviation": "ALL",
    "symbol": "&#76;&#101;&#107;"
  },
  {
    "currency": "Afghanistan Afghani",
    "abbreviation": "AFN",
    "symbol": "&#1547;"
  },
  {
    "currency": "Argentina Peso",
    "abbreviation": "ARS",
    "symbol": "&#36;"
  },
  {
    "currency": "Aruba Guilder",
    "abbreviation": "AWG",
    "symbol": "&#402;"
  },
  {
    "currency": "Australia Dollar",
    "abbreviation": "AUD",
    "symbol": "&#36;"
  },
  {
    "currency": "Azerbaijan New Manat",
    "abbreviation": "AZN",
    "symbol": "&#1084;&#1072;&#1085;"
  },
  {
    "currency": "Bahamas Dollar",
    "abbreviation": "BSD",
    "symbol": "&#36;"
  },
  {
    "currency": "Barbados Dollar",
    "abbreviation": "BBD",
    "symbol": "&#36;"
  },
  {
    "currency": "Belarus Ruble",
    "abbreviation": "BYR",
    "symbol": "&#112;&#46;"
  },
  {
    "currency": "Belize Dollar",
    "abbreviation": "BZD",
    "symbol": "&#66;&#90;&#36;"
  },
  {
    "currency": "Bermuda Dollar",
    "abbreviation": "BMD",
    "symbol": "&#36;"
  },
  {
    "currency": "Bolivia Boliviano",
    "abbreviation": "BOB",
    "symbol": "&#36;&#98;"
  },
  {
    "currency": "Bosnia and Herzegovina Convertible Marka",
    "abbreviation": "BAM",
    "symbol": "&#75;&#77;"
  },
  {
    "currency": "Botswana Pula",
    "abbreviation": "BWP",
    "symbol": "&#80;"
  },
  {
    "currency": "Bulgaria Lev",
    "abbreviation": "BGN",
    "symbol": "&#1083;&#1074;"
  },
  {
    "currency": "Brazil Real",
    "abbreviation": "BRL",
    "symbol": "&#82;&#36;"
  },
  {
    "currency": "Brunei Darussalam Dollar",
    "abbreviation": "BND",
    "symbol": "&#36;"
  },
  {
    "currency": "Cambodia Riel",
    "abbreviation": "KHR",
    "symbol": "&#6107;"
  },
  {
    "currency": "Canada Dollar",
    "abbreviation": "CAD",
    "symbol": "&#36;"
  },
  {
    "currency": "Cayman Islands Dollar",
    "abbreviation": "KYD",
    "symbol": "&#36;"
  },
  {
    "currency": "Chile Peso",
    "abbreviation": "CLP",
    "symbol": "&#36;"
  },
  {
    "currency": "China Yuan Renminbi",
    "abbreviation": "CNY",
    "symbol": "&#165;"
  },
  {
    "currency": "Colombia Peso",
    "abbreviation": "COP",
    "symbol": "&#36;"
  },
  {
    "currency": "Costa Rica Colon",
    "abbreviation": "CRC",
    "symbol": "&#8353;"
  },
  {
    "currency": "Croatia Kuna",
    "abbreviation": "HRK",
    "symbol": "&#107;&#110;"
  },
  {
    "currency": "Cuba Peso",
    "abbreviation": "CUP",
    "symbol": "&#8369;"
  },
  {
    "currency": "Czech Republic Koruna",
    "abbreviation": "CZK",
    "symbol": "&#75;&#269;"
  },
  {
    "currency": "Denmark Krone",
    "abbreviation": "DKK",
    "symbol": "&#107;&#114;"
  },
  {
    "currency": "Dominican Republic Peso",
    "abbreviation": "DOP",
    "symbol": "&#82;&#68;&#36;"
  },
  {
    "currency": "East Caribbean Dollar",
    "abbreviation": "XCD",
    "symbol": "&#36;"
  },
  {
    "currency": "Egypt Pound",
    "abbreviation": "EGP",
    "symbol": "&#163;"
  },
  {
    "currency": "El Salvador Colon",
    "abbreviation": "SVC",
    "symbol": "&#36;"
  },
  {
    "currency": "Estonia Kroon",
    "abbreviation": "EEK",
    "symbol": "&#107;&#114;"
  },
  {
    "currency": "Euro Member Countries",
    "abbreviation": "EUR",
    "symbol": "&#8364;"
  },
  {
    "currency": "Falkland Islands (Malvinas) Pound",
    "abbreviation": "FKP",
    "symbol": "&#163;"
  },
  {
    "currency": "Fiji Dollar",
    "abbreviation": "FJD",
    "symbol": "&#36;"
  },
  {
    "currency": "Ghana Cedis",
    "abbreviation": "GHC",
    "symbol": "&#162;"
  },
  {
    "currency": "Gibraltar Pound",
    "abbreviation": "GIP",
    "symbol": "&#163;"
  },
  {
    "currency": "Guatemala Quetzal",
    "abbreviation": "GTQ",
    "symbol": "&#81;"
  },
  {
    "currency": "Guernsey Pound",
    "abbreviation": "GGP",
    "symbol": "&#163;"
  },
  {
    "currency": "Guyana Dollar",
    "abbreviation": "GYD",
    "symbol": "&#36;"
  },
  {
    "currency": "Honduras Lempira",
    "abbreviation": "HNL",
    "symbol": "&#76;"
  },
  {
    "currency": "Hong Kong Dollar",
    "abbreviation": "HKD",
    "symbol": "&#36;"
  },
  {
    "currency": "Hungary Forint",
    "abbreviation": "HUF",
    "symbol": "&#70;&#116;"
  },
  {
    "currency": "Iceland Krona",
    "abbreviation": "ISK",
    "symbol": "&#107;&#114;"
  },
  {
    "currency": "India Rupee",
    "abbreviation": "INR",
    "symbol": "&#8360;"
  },
  {
    "currency": "Indonesia Rupiah",
    "abbreviation": "IDR",
    "symbol": "&#82;&#112;"
  },
  {
    "currency": "Iran Rial",
    "abbreviation": "IRR",
    "symbol": "&#65020;"
  },
  {
    "currency": "Isle of Man Pound",
    "abbreviation": "IMP",
    "symbol": "&#163;"
  },
  {
    "currency": "Israel Shekel",
    "abbreviation": "ILS",
    "symbol": "&#8362;"
  },
  {
    "currency": "Jamaica Dollar",
    "abbreviation": "JMD",
    "symbol": "&#74;&#36;"
  },
  {
    "currency": "Japan Yen",
    "abbreviation": "JPY",
    "symbol": "&#165;"
  },
  {
    "currency": "Jersey Pound",
    "abbreviation": "JEP",
    "symbol": "&#163;"
  },
  {
    "currency": "Kazakhstan Tenge",
    "abbreviation": "KZT",
    "symbol": "&#1083;&#1074;"
  },
  {
    "currency": "Korea (North) Won",
    "abbreviation": "KPW",
    "symbol": "&#8361;"
  },
  {
    "currency": "Korea (South) Won",
    "abbreviation": "KRW",
    "symbol": "&#8361;"
  },
  {
    "currency": "Kyrgyzstan Som",
    "abbreviation": "KGS",
    "symbol": "&#1083;&#1074;"
  },
  {
    "currency": "Laos Kip",
    "abbreviation": "LAK",
    "symbol": "&#8365;"
  },
  {
    "currency": "Latvia Lat",
    "abbreviation": "LVL",
    "symbol": "&#76;&#115;"
  },
  {
    "currency": "Lebanon Pound",
    "abbreviation": "LBP",
    "symbol": "&#163;"
  },
  {
    "currency": "Liberia Dollar",
    "abbreviation": "LRD",
    "symbol": "&#36;"
  },
  {
    "currency": "Lithuania Litas",
    "abbreviation": "LTL",
    "symbol": "&#76;&#116;"
  },
  {
    "currency": "Macedonia Denar",
    "abbreviation": "MKD",
    "symbol": "&#1076;&#1077;&#1085;"
  },
  {
    "currency": "Malaysia Ringgit",
    "abbreviation": "MYR",
    "symbol": "&#82;&#77;"
  },
  {
    "currency": "Mauritius Rupee",
    "abbreviation": "MUR",
    "symbol": "&#8360;"
  },
  {
    "currency": "Mexico Peso",
    "abbreviation": "MXN",
    "symbol": "&#36;"
  },
  {
    "currency": "Mongolia Tughrik",
    "abbreviation": "MNT",
    "symbol": "&#8366;"
  },
  {
    "currency": "Mozambique Metical",
    "abbreviation": "MZN",
    "symbol": "&#77;&#84;"
  },
  {
    "currency": "Namibia Dollar",
    "abbreviation": "NAD",
    "symbol": "&#36;"
  },
  {
    "currency": "Nepal Rupee",
    "abbreviation": "NPR",
    "symbol": "&#8360;"
  },
  {
    "currency": "Netherlands Antilles Guilder",
    "abbreviation": "ANG",
    "symbol": "&#402;"
  },
  {
    "currency": "New Zealand Dollar",
    "abbreviation": "NZD",
    "symbol": "&#36;"
  },
  {
    "currency": "Nicaragua Cordoba",
    "abbreviation": "NIO",
    "symbol": "&#67;&#36;"
  },
  {
    "currency": "Nigeria Naira",
    "abbreviation": "NGN",
    "symbol": "&#8358;"
  },
  {
    "currency": "Korea (North) Won",
    "abbreviation": "KPW",
    "symbol": "&#8361;"
  },
  {
    "currency": "Norway Krone",
    "abbreviation": "NOK",
    "symbol": "&#107;&#114;"
  },
  {
    "currency": "Oman Rial",
    "abbreviation": "OMR",
    "symbol": "&#65020;"
  },
  {
    "currency": "Pakistan Rupee",
    "abbreviation": "PKR",
    "symbol": "&#8360;"
  },
  {
    "currency": "Panama Balboa",
    "abbreviation": "PAB",
    "symbol": "&#66;&#47;&#46;"
  },
  {
    "currency": "Paraguay Guarani",
    "abbreviation": "PYG",
    "symbol": "&#71;&#115;"
  },
  {
    "currency": "Peru Nuevo Sol",
    "abbreviation": "PEN",
    "symbol": "&#83;&#47;&#46;"
  },
  {
    "currency": "Philippines Peso",
    "abbreviation": "PHP",
    "symbol": "&#8369;"
  },
  {
    "currency": "Poland Zloty",
    "abbreviation": "PLN",
    "symbol": "&#122;&#322;"
  },
  {
    "currency": "Qatar Riyal",
    "abbreviation": "QAR",
    "symbol": "&#65020;"
  },
  {
    "currency": "Romania New Leu",
    "abbreviation": "RON",
    "symbol": "&#108;&#101;&#105;"
  },
  {
    "currency": "Russia Ruble",
    "abbreviation": "RUB",
    "symbol": "&#1088;&#1091;&#1073;"
  },
  {
    "currency": "Saint Helena Pound",
    "abbreviation": "SHP",
    "symbol": "&#163;"
  },
  {
    "currency": "Saudi Arabia Riyal",
    "abbreviation": "SAR",
    "symbol": "&#65020;"
  },
  {
    "currency": "Serbia Dinar",
    "abbreviation": "RSD",
    "symbol": "&#1044;&#1080;&#1085;&#46;"
  },
  {
    "currency": "Seychelles Rupee",
    "abbreviation": "SCR",
    "symbol": "&#8360;"
  },
  {
    "currency": "Singapore Dollar",
    "abbreviation": "SGD",
    "symbol": "&#36;"
  },
  {
    "currency": "Solomon Islands Dollar",
    "abbreviation": "SBD",
    "symbol": "&#36;"
  },
  {
    "currency": "Somalia Shilling",
    "abbreviation": "SOS",
    "symbol": "&#83;"
  },
  {
    "currency": "South Africa Rand",
    "abbreviation": "ZAR",
    "symbol": "&#82;"
  },
  {
    "currency": "Korea (South) Won",
    "abbreviation": "KRW",
    "symbol": "&#8361;"
  },
  {
    "currency": "Sri Lanka Rupee",
    "abbreviation": "LKR",
    "symbol": "&#8360;"
  },
  {
    "currency": "Sweden Krona",
    "abbreviation": "SEK",
    "symbol": "&#107;&#114;"
  },
  {
    "currency": "Switzerland Franc",
    "abbreviation": "CHF",
    "symbol": "&#67;&#72;&#70;"
  },
  {
    "currency": "Suriname Dollar",
    "abbreviation": "SRD",
    "symbol": "&#36;"
  },
  {
    "currency": "Syria Pound",
    "abbreviation": "SYP",
    "symbol": "&#163;"
  },
  {
    "currency": "Taiwan New Dollar",
    "abbreviation": "TWD",
    "symbol": "&#78;&#84;&#36;"
  },
  {
    "currency": "Thailand Baht",
    "abbreviation": "THB",
    "symbol": "&#3647;"
  },
  {
    "currency": "Trinidad and Tobago Dollar",
    "abbreviation": "TTD",
    "symbol": "&#84;&#84;&#36;"
  },
  {
    "currency": "Turkey Lira",
    "abbreviation": "TRY",
    "symbol": "&#8356;"
  },
  {
    "currency": "Turkey Lira",
    "abbreviation": "TRL",
    "symbol": "&#8356;"
  },
  {
    "currency": "Tuvalu Dollar",
    "abbreviation": "TVD",
    "symbol": "&#36;"
  },
  {
    "currency": "Ukraine Hryvna",
    "abbreviation": "UAH",
    "symbol": "&#8372;"
  },
  {
    "currency": "United Kingdom Pound",
    "abbreviation": "GBP",
    "symbol": "&#163;"
  },
  {
    "currency": "United States Dollar",
    "abbreviation": "USD",
    "symbol": "&#36;"
  },
  {
    "currency": "Uruguay Peso",
    "abbreviation": "UYU",
    "symbol": "&#36;&#85;"
  },
  {
    "currency": "Uzbekistan Som",
    "abbreviation": "UZS",
    "symbol": "&#1083;&#1074;"
  },
  {
    "currency": "Venezuela Bolivar",
    "abbreviation": "VEF",
    "symbol": "&#66;&#115;"
  },
  {
    "currency": "Viet Nam Dong",
    "abbreviation": "VND",
    "symbol": "&#8363;"
  },
  {
    "currency": "Yemen Rial",
    "abbreviation": "YER",
    "symbol": "&#65020;"
  },
  {
    "currency": "Zimbabwe Dollar",
    "abbreviation": "ZWD",
    "symbol": "&#90;&#36;"
  }
],
            loadingData: false,
            errorLoadingData: [],
            onPageValidationErrors: [],
            fixedPriceUid:process.env.VUE_APP_FIXED_PRICE,
            priceonreqFlag:false,
            //Number of date slot panes to show
            dateRange : 2,
            holdDateDiff:0,
            tempHoldPrevDate:null,
            paymentconfigobj:null,
            selectedPayGateway:null,
            selectedPayGatewayName:null,
            selectedPayGatewayId:null,
            raz_api_key:null, 
            raz_amount:null,
            raz_curncy:null,
            raz_order_id:null,
            raz_order_desc:null,
            raz_customer_name:null,
            raz_customer_email:null,
            raz_customer_mobile:null,
            tempAppointmentId:"",
            posturl:process.env.VUE_APP_ANONYMOUS_API_BASE,//"http://localhost:49600/api/v1/"
            showpaybutton:false,
            rzp1:null,
            staffcolor:null,
            paymentbuttonscript:null,
            showFreeTrialButton:false,
            remainingdays:0,
            tenantcreateddate:null,
        }
    },
    created(){
        this.getInitialDateTimeSetting();
        this.getCountry();
        if(this.$store.getters.tenantId){
           this.getCurrentSubscription(this.$store.getters.tenantId);
        }
        localStorage.removeItem("pmntcptrddata");
       
    },
    mounted(){
        this.getURLDetails();

    },
    components: {
        'app-personalised-header': PersonalisedHeader,
        'Consent':Consent,
        'app-stepper': Stepper
    },
    computed: {
        ...mapGetters([
            'tenantId',
            'protocol',
            'subDomain',
            'businessId',
            'businessLogo',
            'businessName',    
            'businessType',
            'businessWebsiteUrl',
            'providerTitle',
            'providerFirstName',
            'providerLastName',
            'providerEmail',
            'providerId',
            'providerPic',
            'providerColorCode',
            'providerPhone',
            'locationName',
            'clinicContactNumbers',
            'clinicAddress',
            'locationId',
            'locationCurrency',
            'locationTz',
            'mapUrlEmbedded',
            'clientTz',
            'loading',
            'loadingMessage',
            'error',
            'errorMessage'
        ]),
        tenantIdCheck(){
            return this.$store.getters.tenantId;
        },
        currencylocation(){
                debugger;
            var curr=  this.locationbasedcurrency.filter(ele=>ele.abbreviation===this.$store.getters.locationCurrency);
                if(curr.length>0)
           {return curr[0].symbol;}
           else{
               return this.$store.getters.locationCurrency;
           }
        }
    },
    watch: {
        tenantIdCheck (newVal, oldVal) {
        //console.log('We have ${newVal} now, yaay!');
        if(newVal){
          //  this.getServiceGroups(newVal);
           // this.getServices(newVal);
           this.getCurrentSubscription(newVal);
        }
        }
    },
    methods: 
    {
         termsNConditionsPopup() {
      // debugger;
      this.showCnfrmPopUp = true;
      // this.showTermsandConditionsPopup = true;
      //      document.body.classList.add("modal-mask-open");
    },
        formatPrice(value) {
            // console.log("I am here when connected to vpn...")
            let val = (value/1).toFixed(2)
            return val.toString()
        },
        addDuration(slotDateString){
            //console.log(slotDateString);
            let dateval = moment(slotDateString, 'YYYY-MM-DD hh:mm A');
            //console.log(dateval);
            let dateFormatted = dateval.add(this.selectedService.duration, 'minutes').format('hh:mm A');
            
            //console.log(dateFormatted);
            return dateFormatted;
        },
        getServiceGroups(tenantId){
            // Get and Set Service Groups 
            // get service groups ... 
            this.loadingData = false;
            let burl = process.env.VUE_APP_FRONTEND_API_BASE;
            let url = process.env.VUE_APP_FRONTEND_API_BASE+"/api/service-group?isac=1";

            //-------------------
            // `async` wrapper to configure `localforage` and instantiate `axios` with `axios-cache-adapter`
            async function configure () {
                // Register the custom `memoryDriver` to `localforage`
                await localforage.defineDriver(memoryDriver)
            
                // Create `localforage` instance
                const store = localforage.createInstance({
                    // List of drivers used
                    driver: [
                    localforage.INDEXEDDB,
                    localforage.LOCALSTORAGE,
                    memoryDriver._driver
                    ],
                    // Prefix all storage keys to prevent conflicts
                    name: 'genamet-cache'
                })
            
                // Create `axios` instance with pre-configured `axios-cache-adapter` using a `localforage` store
                return setup({
                    // `axios` options
                    baseURL: burl,
                    headers: {
                        'Content-Type': 'application/json',
                        'x_tenant_id': tenantId,
                        'Accept-Encoding': 'gzip'
                    },        
                    // `axios-cache-adapter` options
                    cache: {
                        maxAge: 15 * 60 * 1000,
                        store, // Pass `localforage` store to `axios-cache-adapter`,
                        exclude: { query: false }
                    }
                })
            }
            
            configure().then(async (api) => {
                //console.log('r0')
                const response = await api.get('/api/service-group?isac=1')
                //console.log('r1')
                //console.log(response)
                this.loadingData = false;
                this.errorLoadingData.length = 0;           
                this.errorLoadingData = [];
                this.serviceGroups = response.data;
            }).catch(e => {
                this.loadingData = false;
                this.errorLoadingData.push(e);
            });

            setTimeout(function(){
                    configure().then(async (api) => {
                        //console.log('r2')
                        const response = await api.get('/api/service-group?isac=1')
                        //console.log('r3')
                        //console.log(response)
                        this.loadingData = false;
                        this.errorLoadingData.length = 0;           
                        this.errorLoadingData = [];
                        this.serviceGroups = response.data;
                    }).catch(e => {
                        this.loadingData = false;
                        this.errorLoadingData.push(e);
                    });
                }.bind(this), 5000
            );

            //-------------------

            // axios.get(
            //     url, 
            //     {
            //         headers: {
            //             'Content-Type': 'application/json',
            //             'x_tenant_id': tenantId,
            //             'Accept-Encoding': 'gzip'
            //         }
            //     }
            // ).then(response =>{
            //     this.loadingData = false;
            //     this.errorLoadingData.length = 0;           
            //     this.errorLoadingData = [];
            //     this.serviceGroups = response.data;
            // }).catch(e => {
            //     this.loadingData = false;
            //     this.errorLoadingData.push(e);
            // });
            // -- get service groups ends 

        },
        getCurrentSubscription(tenantId)
        {debugger
             let url = process.env.VUE_APP_FRONTEND_API_BASE+"/api/subscription";
            axios.get(
                url, 
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'x_tenant_id': tenantId,
                        'Accept-Encoding': 'gzip'
                    }
                }
                 ).then(response =>{
                     console.log("loading data");
                     console.log(response.data);
                  if (response.data) {
                    var subscription_package = response.data.tenant_data.package;
                    if(subscription_package!=null){
                     if (subscription_package.name === "Trial Plan") {
                        this.showFreeTrialButton = true;
                        localStorage.setItem("showFreeTrialButton", true);
                        localStorage.setItem("currentplanvalidityindays", subscription_package.validity_in_days);
                        }
                     else{
                        this.showFreeTrialButton = false;
                        localStorage.setItem("showFreeTrialButton", false);
                     localStorage.setItem("currentplanvalidityindays",  subscription_package.validity_in_days);
                        }
                     var transactionlist = response.data.transaction_log_data;
                     if(transactionlist.length > 0)
                     {
                        var filtersubscriptionplan = response.data.transaction_log_data.filter(x => x.package_name === "Trial Plan");
                        if(filtersubscriptionplan.length > 0)
                        {
                            filtersubscriptionplan[0].created_date = moment(filtersubscriptionplan[0].created_date).format("YYYY-MM-DD");
                            const start =  filtersubscriptionplan[0].created_date;
                            this.tenantcreateddate= filtersubscriptionplan[0].created_date;
                            const todaydate = moment().format('YYYY-MM-DD');
                            const end = moment(todaydate);
                            const diff = end.diff(start, "days");
                            const validity_in_days =  localStorage.getItem("currentplanvalidityindays");
                            if(validity_in_days != null)
                            {
                            const remainingdays = parseInt(validity_in_days) - diff; 
                            localStorage.setItem("remainingdays", remainingdays);
                            this.remainingdays = remainingdays;
                            }
                        }
                     }
                     const createdate=moment(process.env.VUE_APP_CREATE_DATE_FROM).format("YYYY-MM-DD");
                     const datetenantcreated=moment(createdate);
                     const diffdays = datetenantcreated.diff(this.tenantcreateddate, "days");
                     if(this.showFreeTrialButton && this.remainingdays<=0 && diffdays<=0 ){
                         this.noservicemsg=true;
                         console.log("No Service fetched");
                     }
                     else{
                         this.getServiceGroups(this.$store.getters.tenantId);
                         this.getServices(this.$store.getters.tenantId);
                         console.log("Service fetched");
                        }
                    }
            else{
                 this.getServiceGroups(this.$store.getters.tenantId);
                 this.getServices(this.$store.getters.tenantId);
                 console.log("Service fetched");
                }
           }
    
               
                //console.log("this.services >>>>>",this.services);
            }).catch(e => {
                this.loadingData = false;
                this.errorLoadingData.push(e);
            });
        },
        getServices(tenantId){
            // Get and Set Services 
            // get services ... 
            this.loadingData = false;
            let stidVal = this.$route.params.staffid;
            let lidVal = this.$route.params.locid;
            let url = process.env.VUE_APP_FRONTEND_API_BASE+"/api/service?stid="+stidVal+"&lid="+lidVal+"&isin=0&isac=1";
            axios.get(
                url, 
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'x_tenant_id': tenantId,
                        'Accept-Encoding': 'gzip'
                    }
                }
            ).then(response =>{
                this.loadingData = false;
                this.errorLoadingData.length = 0;
                this.errorLoadingData = [];
                this.services = response.data;
                //console.log("this.services >>>>>",this.services);
            }).catch(e => {
                this.loadingData = false;
                this.errorLoadingData.push(e);
            });
            // -- get services 

        },
        slotIsBefore(slot){
            //alert(moment(slot));
            //alert(moment());
            return moment(slot).isBefore(moment());
        },
        selectService(service){
            if(service.id == this.selectedServiceId){
                console.log(service.id + " <<1>> " + this.selectedServiceId);
                this.selectedService.length = 0;
                this.selectedServiceId.length = 0;
                this.selectedServiceId = [];
            }else{
                console.log(service.id + " <<2>> " + this.selectedServiceId);
                console.log('about to validate service selection!');
                this.selectedService = service;  
                this.selectedServiceId = [service.id];             
                this.validateStep1();
            }
            this.selectedSlot = "";
        },
        validateStep1(){
            if(this.selectedService.id){
                 
                if(this.selectedService.booking_options == process.env.VUE_APP_BOOKING_OPTIONS_BD){
                    this.showStep = 2;
                }
                if(this.selectedService.booking_options == process.env.VUE_APP_BOOKING_OPTIONS_BVR){
                    this.showStep = 3;
                }
                //Fetch RazorPay Config
                this.showpaybutton=false;
                this.fetchpaymentconfigobj();

                this.step1Valid = true;
                this.onPageValidationErrors.length = 0;
                this.errorLoadingData = [];
                this.getAvailableSlots();
            }
            else {
                this.showStep = 1;  
                this.step1Valid = false;
                this.onPageValidationErrors.push('Please select a Service!');
            }  
            window.scrollTo(0, 0);                   
        },
        getAvailableSlots(){
            if(this.selectedService.booking_options == process.env.VUE_APP_BOOKING_OPTIONS_BD){
                this.loadingData = true;
                this.selectedSlot = "";
                this.selectedSlotId.length = 0;
                this.selectedSlotId = [];
                
                //this.fltDPckr1=null;
                let sd=null,ed=null;
                var self = this;
                if(self.displayedStartDate._isAMomentObject){
                    var displayedStartDateFormat = self.displayedStartDate._f;
                    self.displayedStartDate=self.displayedStartDate._i;
                    sd = moment(this.displayedStartDate,displayedStartDateFormat).format("YYYY-MM-DD 00:00:00");
                    ed = moment(this.displayedEndDate).format("YYYY-MM-DD 00:00:00");
                }
                else{
                    sd = moment(moment(this.displayedStartDate.split(' ')[0],"YYYY-MM-DD")).format("YYYY-MM-DD 00:00:00");
                    ed = moment(moment(this.displayedEndDate.split(' ')[0],"YYYY-MM-DD")).format("YYYY-MM-DD 00:00:00");
                }
                // call available slots service ... 
                let url = process.env.VUE_APP_FRONTEND_API_BASE+"/api/slots?loid="+ this.$store.getters.locationId +"&sd=" + sd + "&ed=" + ed + "&lotz=" + this.$store.getters.locationTz + "&cltz=" + this.$store.getters.clientTz + "&stid=" + this.$store.getters.providerId + "&sdur="+ (parseInt(this.selectedService.pre_service_buffer_time) + parseInt(this.selectedService.duration) + parseInt(this.selectedService.post_service_buffer_time)) + "&slinc=" + this.selectedService.slotincrement + "";
                //console.log(url);
                axios.get(url, 
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'x_tenant_id': this.$store.getters.tenantId,
                        'Accept-Encoding': 'gzip'
                    }
                })
                .then(response => {
                    this.availableSlots = response.data;
                    this.loadingData = false;
                    this.errorLoadingData.length = 0;
                    this.errorLoadingData = [];
                    //get the flatpicker calender
                    if(document.getElementById("startflatpickr")){
                        if(!self.fltDPckr1){
                            self.fltDPckr1 = flatpickr(document.getElementById("startflatpickr"),{
                                onClose: function(dateObj, dateStr) {
                                    self.showStartCalender(dateObj);
                                },
                                "locale": {
                                    "firstDayOfWeek": 1 // start week on Monday
                                },
                                minDate: 'today',
                                //maxDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
                                //mode: 'range',
                                altInput: true,
                                altFormat: "J F, Y",
                                dateFormat: "d-m-Y",
                                defaultDate: moment(self.displayedStartDate).format("DD-MM-YYYY"),
                                static: false
                            });
                            console.log("FLATPICKER OBJECT>>>>",self.fltDPckr1);
                        }
                        else{
                            if(self.displayedStartDate._isAMomentObject){
                                self.displayedStartDate=self.displayedStartDate._i;
                            }                        
                            if(self.displayedStartDate.split(' ').length==1){
                                self.fltDPckr1.destroy();
                                self.fltDPckr1 = flatpickr(document.getElementById("startflatpickr"),{
                                    onClose: function(dateObj, dateStr) {
                                        self.showStartCalender(dateObj);
                                    },
                                    "locale": {
                                        "firstDayOfWeek": 1 // start week on Monday
                                    },
                                    minDate: 'today',
                                    //maxDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
                                    //mode: 'range',
                                    altInput: true,
                                    altFormat: "J F, Y",
                                    dateFormat: "d-m-Y",
                                    defaultDate: moment(self.displayedStartDate,"DD-MM-YYYY").format("DD-MM-YYYY"),
                                    static: false
                                });
                                //let parsedateToSet = self.fltDPckr1.parseDate(self.displayedStartDate,"d-m-Y");
                                //self.fltDPckr1.setDate(parsedateToSet,true,"d-m-Y");
                            }
                            else{
                                let getDtStr = moment(self.displayedStartDate.split(' ')[0]).format("DD-MM-YYYY");
                                //let parsedateToSet = self.fltDPckr1.parseDate(getDtStr,"d-m-Y");
                                //self.fltDPckr1.setDate(parsedateToSet,true,"d-m-Y");
                                self.fltDPckr1.destroy();
                                self.fltDPckr1 = flatpickr(document.getElementById("startflatpickr"),{
                                    onClose: function(dateObj, dateStr) {
                                        self.showStartCalender(dateObj);
                                    },
                                    "locale": {
                                        "firstDayOfWeek": 1 // start week on Monday
                                    },
                                    minDate: 'today',
                                    //maxDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
                                    //mode: 'range',
                                    altInput: true,
                                    altFormat: "J F, Y",
                                    dateFormat: "d-m-Y",
                                    defaultDate: moment(getDtStr,"DD-MM-YYYY").format("DD-MM-YYYY"),
                                    static: false
                                });
                            }
                        }
                        if(self.displayedStartDate._isAMomentObject){
                            self.displayedStartDate=self.displayedStartDate._i;
                        }
                        else{
                            self.displayedStartDate = moment(self.displayedStartDate,"DD-MM-YYYY");
                        }
                    }
                })
                .catch(e => {
                    this.loadingData = false;
                    this.errorLoadingData.push(e);
                })
            }
        },
        validateStep2(){
            //console.log('vs2 A');
            if(this.selectedSlot){
                this.showStep = 3;
                this.step2Valid = true;
                this.onPageValidationErrors.length = 0;
                this.onPageValidationErrors = [];
            }
            else {
                this.showStep = 2;
                this.step2Valid = false;
                this.onPageValidationErrors.push('Please select a Time Slot!');
            }
                
            window.scrollTo(0, 0);   
            //console.log('vs2 B');              
        },
        selectSlot(slot){
            let slotdt = slot.split('|')[0];
            if(!this.slotIsBefore(slotdt)){
                let slotAvailability = slot.split('|')[1];
                if (slotAvailability != 'U'){
                    //console.log(slotdt + '==' + this.selectedSlotId)
                    if(slotdt == this.selectedSlot){
                        this.selectedSlot = "";
                        this.selectedSlotId.length = 0;
                        this.selectedSlotId = [];
                    }else{
                        this.selectedSlot = slotdt;
                        this.selectedSlotId = [slotdt];
                        this.validateStep2();
                    }
                }
            }
        },
        nextDateSet(){
            this.datePage ++;
            //let dateRange = 2;
            if(this.datePage == 1){
                let dateval = moment();
                let timeval = "00:00:00";
                this.displayedStartDate = (moment(dateval).format("YYYY-MM-DD") + " " + timeval);
                this.displayedEndDate = moment(this.displayedStartDate).add(this.dateRange, "days");
                this.displayedEndDate = (moment(this.displayedEndDate).format("YYYY-MM-DD") + " " + timeval);
                //this.displayedStartDate =moment();
                //this.displayedEndDate = moment(this.displayedStartDate).add(6, "days");
            }else{
                this.displayedStartDate = moment(this.displayedStartDate).add((this.dateRange+1), "days");
                this.displayedEndDate = moment(this.displayedStartDate).add(this.dateRange, "days");
            }
            this.date = moment(this.displayedStartDate).format("YYYY-MM-DD");
            this.minDate = moment().format("YYYY-MM-DD");
            this.getAvailableSlots();
        },
        prevDateSet(){
            this.datePage --;
            //let dateRange = 2;
            this.minDate = moment().format("YYYY-MM-DD");
            if(this.minDate >= moment(this.displayedStartDate).subtract((this.dateRange+1), "days").format("YYYY-MM-DD")){
                this.datePage = 1;                 
            }
            
            //alert(this.datePage);

            if(this.datePage == 1){
                let dateval = moment();
                let timeval = "00:00:00";
                this.displayedStartDate = (moment(dateval).format("YYYY-MM-DD") + " " + timeval);
                this.displayedEndDate = moment(this.displayedStartDate).add(this.dateRange, "days");
                this.displayedEndDate = (moment(this.displayedEndDate).format("YYYY-MM-DD") + " " + timeval);
                //this.displayedStartDate = moment();
                //this.displayedEndDate = moment(this.displayedStartDate).add(6, "days");
            }else{
                this.displayedStartDate = moment(this.displayedStartDate).subtract((this.dateRange+1), "days");
                this.displayedEndDate = moment(this.displayedEndDate).subtract((this.dateRange+1), "days");
            }
            this.date = moment(this.displayedStartDate).format("YYYY-MM-DD");                
            this.getAvailableSlots();
        },
        validateStep3:function(e) {
            //console.log('vs3 A');
            window.scrollTo(0, 0);
            this.onPageValidationErrors.length = 0;
            this.onPageValidationErrors = [];

            if (!this.personName.trim()) {
                this.personName = "";
                this.onPageValidationErrors.push('Your Name is required.');
            } else if (!this.fullname(this.personName)) {
                this.onPageValidationErrors.push('Your Full Name is not valid. Only alphabets, hyphens/dashes, white-spaces, apostrophes and dots/periods are allowed.');
            } 

            if (!this.personEmail.trim()) {
                this.personEmail = "";
                this.onPageValidationErrors.push('Email is required.');
            } else if (!this.validEmail(this.personEmail)) {
                this.onPageValidationErrors.push('Please enter valid Email.');
            } 

            if (!this.personMobileCC) {
                this.onPageValidationErrors.push('Country Code is required.');
            }

            if (!this.personMobile.trim()) {
                this.personMobile = "";
                //console.log('Mobile not present!');
                this.onPageValidationErrors.push('Mobile is required.');
            } else if (!this.phonenumber(this.personMobile)) {
                //console.log('Mobile not valid!');
                this.onPageValidationErrors.push('Please enter a 10 digit long valid Mobile number (without dashes, spaces or brackets). ');
            }   

            if(this.relationshipWithPatient != 'Self'){
                if (!this.nameOfPatient.trim()) {
                    this.nameOfPatient = "";
                    this.onPageValidationErrors.push('Patient\'s Full Name is required.');
                } else if (!this.fullname(this.nameOfPatient)) {
                    this.onPageValidationErrors.push('Patient\'s Full Name is not valid. Only alphabets, hyphens/dashes, white-spaces, apostrophes and dots/periods are allowed.');
                }
            }
            
            if (!this.genderOfPatient.trim()) {
                this.onPageValidationErrors.push('Patient\'s Gender is required.');
            }

            if(this.patientConsent!=true){
                this.onPageValidationErrors.push('Patient\'s consent is required.'); 
            }
            
            if(this.selectedService.booking_options == process.env.VUE_APP_BOOKING_OPTIONS_BVR){
                if(this.selectedService.group_name.includes("Email")){
                    this.preferredScheduleNotes = "* Not applicable for email consultations";
                }
                if(!this.textArea(this.preferredScheduleNotes.trim())){
                    this.preferredScheduleNotes = "";
                    //console.log('Preferred Schedule not valid!');
                    this.onPageValidationErrors.push('Please provide details of your preferred appointment schedule (between 15 and 500 allowed)');
                }
            }

            if (this.onPageValidationErrors.length > 0) {
                //this.onPageValidationErrors.push('Please fill in all fields correctly!');
                this.step3Valid = false;
            }else{
                this.showStep = 4;
                this.step4Valid = true;
                this.onPageValidationErrors.length = 0;
                this.onPageValidationErrors = [];
                this.step3Valid = true;
                // this.showpaybutton=false;
                // this.fetchpaymentconfigobj();
            }
            e.preventDefault();
            //console.log('vs3 B');
        },
        validEmail: function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        phonenumber: function (mobile) {
            var phoneno = /^\d{10}$/;
            if(mobile.match(phoneno)){
                return true;
            }else{
                return false;
            }
        }, 
        fullname: function (name) {
            var pattern = /^[a-zA-Z-'. ]+$/;
            if(name.match(pattern)){
                return true;
            }else{
                return false;
            }
        },
        textArea: function (notes) {
            if(notes.length > 15 && notes.length <= 500){
                return true;
            }else{
                return false;
            }
        },
        truncateText: function (textVal, length) {
            return textVal.substring(0,length) + " ... ";
        },
        clear () {
            this.onPageValidationErrors.length = 0;
            this.onPageValidationErrors = [];
            this.personName = "";
            this.personEmail = "";
            this.personMobile = "";
            this.personMobileCC = "91";
            this.preferredScheduleNotes = "";
            this.patientConsent = true;
        },
        clearNotes () {
            this.onPageValidationErrors.length = 0;
            this.onPageValidationErrors = [];
            this.preferredScheduleNotes = "";
        },
        bookNow(pay_now){
            //this.fetchpaymentconfigobj(pay_now);
            this.selectAndBookNow(pay_now);           
        },
        getURLDetails() {
            var currentUrl = window.location.hostname;
            //console.log(currentUrl);
            this.currentURL = window.location.pathname;
            if( currentUrl.indexOf('pranav-skin-and-cosmetology-clinic') >= 0){
                this.showServiceCondition = "y";
            }
        },
        goBack(step){
            this.onPageValidationErrors.length = 0;
            this.onPageValidationErrors = [];
            this.showStep = step;
            if(this.selectedService.group_name.includes("Email"))
           { this.preferredScheduleNotes = "";}
            if(step==1){
                this.getInitialDateTimeSetting();
            }
            if(step==2){
                this.getInitialDateTimeSetting();
                this.getAvailableSlots();
            }
            window.scrollTo(0, 0);
        },
        getCountry(){
            var self = this;
           
            //changed by Anuj
            this.browser_country = 'IN';
            let url = "https://api.ipgeolocation.io/ipgeo?apiKey=a86929715b35444b916015f1f1112bac";
            //let url = "https://extreme-ip-lookup.com/json/";
            
            var config = {
                method: 'get',
                url: 'https://api.ipify.org/?format=json',
            };
            axios(config)
            .then(function (response) {
                if(response && response.data && response.data.ip)
                {
                    console.log("IP=>",JSON.stringify(response.data));
                    //url = url+response.data.ip;
                    let cnfg={
                        method:'get',
                        url:url+"&ip="+response.data.ip
                    };
                    
                    axios(cnfg)
                    .then(response =>{
                    if(response && response.data && response.data.country_code2)
                        {
                            console.log("COUNTRY FETCH>>>>",response.data);
                            // if(response.data.countryCode)
                            // {
                            //     self.browser_country = response.data.countryCode;
                            // }
                            if(response.data.country_code2)
                            {
                                self.browser_country = response.data.country_code2;
                                self.personMobileCC = Number(response.data.calling_code);
                            }
                            // if(self.browser_country != "IN"){
                            //     //self.getExchangeRate();
                            //     //This following line of code is added temporarily
                            //    self.browser_country = "IN" ;
                            // }
                        }
                    }).catch(e => {
                        console.log("Could not detect any country!",e);
                    });
                }
            })
            .catch(function (error) {
                console.log("could not get the ip",error);
            });     
        },
        getExchangeRate(){
            let url = "http://apilayer.net/api/live?access_key=6ab0ef9a5b22cd08a0222e309d844875&currencies=INR";
            let config={
                method:'get',
                url:url, 
                headers: {
                    'Content-Type': 'application/json'
                }
            };
            axios(config).then(response =>{
                //console.log("USD to INR is "+response.data.quotes.USDINR + "!");
                this.exchangeRate = (response.data.quotes.USDINR).toFixed(2);
            }).catch(e => {
                //console.log("No exchange rate!");
            });     
        },
        guid() {
            return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + this.s4() + this.s4();
        },
        s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
        },
        showPriceData(jsonstring){
            if(jsonstring){
                jsonstring=JSON.parse(jsonstring.replace(/'/g, '"').replace(/\(|\)/g, "").replace(/\Decimal/g, ""));
                if(!this.priceonreqFlag && jsonstring.unique_id != this.fixedPriceUid.toString()){
                    this.priceonreqFlag = true;
                }
                return jsonstring.unique_id == this.fixedPriceUid;
            }
        },
        addCss(i){
            if(document.getElementById('tootltipTxt'+i)){
                document.getElementById('tootltipTxt'+i).style.display = "block";
            }
            if(document.getElementById('tootltipArr'+i)){
                document.getElementById('tootltipArr'+i).style.display = "block";
            }
        },
        removeCss(i){
            if(document.getElementById('tootltipTxt'+i)){
                document.getElementById('tootltipTxt'+i).style.display = "none";
            }
            if(document.getElementById('tootltipArr'+i)){
                document.getElementById('tootltipArr'+i).style.display = "none";
            }
        },
        //Date flatpicker
        showStartCalender: function(item) {
            if(item && item.length){
                var self = this;
                var functionToCallFlag = null;
                if(!self.tempHoldPrevDate){
                    self.tempHoldPrevDate = moment().format("YYYY-MM-DD");
                }
                var selectedDate = moment(moment(item[0]).format("YYYY-MM-DD"));
                //self.displayedStartDate = moment(item[0]).format("YYYY-MM-DD")+" 00:00:00";
                //var diffOfMinutes = selectedDate.diff(moment().format("YYYY-MM-DD"), 'minutes');
                var relativeDiff = selectedDate.diff(moment().format("YYYY-MM-DD"), 'seconds');

                var diffOfMinutes = selectedDate.diff(moment(self.tempHoldPrevDate,"YYYY-MM-DD"), 'minutes');

                if(diffOfMinutes>0 && diffOfMinutes>=1440){
                    console.log("RECENT SELECTED DATE IS NEXT DATE");
                    functionToCallFlag = true;
                    this.datePage ++;
                    //let dateRange = 2;
                    // if(this.datePage == 1){
                    //     let dateval = moment();
                    //     let timeval = "00:00:00";
                    //     this.displayedStartDate = (moment(moment(item[0]).format("YYYY-MM-DD") + " " + timeval));
                    //     this.displayedEndDate = moment(this.displayedStartDate).add(this.dateRange, "days");
                    //     this.displayedEndDate = (moment(this.displayedEndDate).format("YYYY-MM-DD") + " " + timeval);
                    //}else{
                        this.displayedStartDate = (moment(selectedDate).format("YYYY-MM-DD") + " 00:00:00");
                        this.displayedStartDate = moment(this.displayedStartDate);
                        this.displayedEndDate = moment(this.displayedStartDate).add(this.dateRange, "days");
                    //}
                    this.date = moment(this.displayedStartDate).format("YYYY-MM-DD");
                    this.minDate = moment().format("YYYY-MM-DD");
                    this.getAvailableSlots();
                }
                else if(diffOfMinutes<0 && Math.abs(diffOfMinutes)>=1440){
                    console.log("RECENT SELECTED DATE IS PREVIOUS DATE");
                    functionToCallFlag = false;

                    this.datePage --;
                    //let dateRange = 2;
                    this.minDate = moment().format("YYYY-MM-DD");
                    if(this.minDate >= moment(this.displayedStartDate).subtract((this.dateRange+1), "days").format("YYYY-MM-DD")){
                        this.datePage = 1;                 
                    }
                    
                    //alert(this.datePage);

                    // if(this.datePage == 1){
                    //     let dateval = moment();
                    //     let timeval = "00:00:00";
                    //     this.displayedStartDate = (moment(dateval).format("YYYY-MM-DD") + " " + timeval);
                    //     this.displayedEndDate = moment(this.displayedStartDate).add(this.dateRange, "days");
                    //     this.displayedEndDate = (moment(this.displayedEndDate).format("YYYY-MM-DD") + " " + timeval);
                    //     //this.displayedStartDate = moment();
                    //     //this.displayedEndDate = moment(this.displayedStartDate).add(6, "days");
                    // }else{
                        this.displayedStartDate = (moment(selectedDate).format("YYYY-MM-DD") + " 00:00:00");
                        this.displayedStartDate = moment(this.displayedStartDate);
                        //this.displayedEndDate = moment(this.displayedEndDate).subtract((this.dateRange+1), "days");
                        this.displayedEndDate = moment(this.displayedStartDate).add(this.dateRange, "days");
                    //}
                    this.date = moment(this.displayedStartDate).format("YYYY-MM-DD");                
                    this.getAvailableSlots();
                }

                // if(diffOfMinutes>=0 || relativeDiff>=0){
                //     if(diffOfMinutes>=1440){
                //         self.datePage ++;
                //     }
                //     else{
                //         self.datePage --;
                //     }
                //     if(this.datePage == 1){
                //         self.displayedStartDate = moment(item[0]).format("YYYY-MM-DD")+" 00:00:00";
                //         self.displayedEndDate = moment(self.displayedStartDate).add(self.dateRange, "days");
                //         self.displayedEndDate = (moment(self.displayedEndDate).format("YYYY-MM-DD")+" 00:00:00");
                //     }
                //     else{
                //         self.displayedStartDate = moment(self.displayedStartDate).add((self.dateRange+1), "days");
                //         self.displayedEndDate = moment(self.displayedStartDate).add(self.dateRange, "days");
                //     }
                //     self.date = moment(self.displayedStartDate).format("YYYY-MM-DD");
                //     self.minDate = moment().format("YYYY-MM-DD");
                //     self.getAvailableSlots();
                // }
                self.tempHoldPrevDate = selectedDate;
            }
        },
        getInitialDateTimeSetting:function(){
            let dateval = moment();
            let timeval = "00:00:00";
            //let dateRange = 2;
            this.displayedStartDate = (moment(dateval).format("YYYY-MM-DD") + " " + timeval);
            this.displayedEndDate = moment(this.displayedStartDate).add(this.dateRange, "days");
            this.displayedEndDate = (moment(this.displayedEndDate).format("YYYY-MM-DD") + " " + timeval);
            this.date = moment(this.displayedStartDate).format("YYYY-MM-DD");
            this.minDate = moment().format("YYYY-MM-DD");
        },
        initializeFlatPicker(dtstr){
            var self = this;
            self.fltDPckr1 = flatpickr(document.getElementById("startflatpickr"),{
                onClose: function(dateObj, dateStr) {
                    self.showStartCalender(dateObj);
                },
                "locale": {
                    "firstDayOfWeek": 1 // start week on Monday
                },
                minDate: 'today',
                //maxDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
                //mode: 'range',
                altInput: true,
                altFormat: "J F, Y",
                dateFormat: "d-m-Y",
                defaultDate: moment(dtstr,"DD-MM-YYYY").format("DD-MM-YYYY"),
                static: false
            });
        },
        fetchpaymentconfigobj(pay_now){
            var config = {
                method: 'get',
                url: this.posturl+"payment/getpaymentconfig?stid="+this.$store.getters.providerId+"&sid="+this.selectedServiceId,
                headers: { 
                    'Content-Type': 'application/json',
                    'x_tenant_id': this.$store.getters.tenantId,
                    'route_entity_name':'/tenant'
                }
            };
            var self = this;
            axios(config)
            .then(function (response) {
                //debugger
                if(response && response.data && response.data && response.data.payment_gateway_config){
                    console.log(response);
                    if(response.data.payment_gateway_config && response.data.payment_gateway_config.length>0){
                        self.paymentconfigobj = response.data.payment_gateway_config[0];
                    }
                    self.staffcolor = response.data.color_code?response.data.color_code:"#07CA76";
                    //SHOW PAY BUTTON
                    self.showpaybutton=true;
                    //self.selectAndBookNow(pay_now);
                }
                else{
                    self.showpaybutton=false;
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        selectAndBookNow(pay_now)
        {
            //this.showpaybutton=false;
            this.errorLoadingData = [];
            //window.scrollTo(0, 0);
            this.bookingData.customer_details.name = this.personName;
            this.bookingData.customer_details.email = this.personEmail;
            this.bookingData.customer_details.mobile = this.personMobile; //this.personMobileCC+''+this.personMobile;
            this.bookingData.customer_details.country_code = this.personMobileCC;
            this.bookingData.customer_details.relationship = this.relationshipWithPatient;
            
            if(this.relationshipWithPatient != 'Self'){
                this.bookingData.customer_details.gender = "";
                this.bookingData.patient_details.name = this.nameOfPatient;
            } else{
                this.bookingData.customer_details.gender = this.genderOfPatient;
                this.bookingData.patient_details.name = this.personName;
            }
            this.bookingData.client_time_zone = this.$store.getters.clientTz;
            this.bookingData.patient_details.email = this.personEmail;
            this.bookingData.patient_details.mobile = this.personMobile; //this.personMobileCC+''+this.personMobile;
            this.bookingData.patient_details.country_code = this.personMobileCC;
            this.bookingData.patient_details.relationship = this.relationshipWithPatient;
            this.bookingData.patient_details.gender = this.genderOfPatient;

            localStorage.setItem("personName", JSON.stringify(this.personName)); 
            localStorage.setItem("personEmail", JSON.stringify(this.personEmail)); 
            localStorage.setItem("personMobile", JSON.stringify(this.personMobile)); 
            localStorage.setItem("personMobileCC", JSON.stringify(this.personMobileCC)); 
            localStorage.setItem("serviceName", JSON.stringify(this.selectedService.name));
            localStorage.setItem("preferredScheduleNotes", JSON.stringify(this.preferredScheduleNotes));
            localStorage.setItem("service_mode", JSON.stringify(this.selectedService.service_mode));
            localStorage.setItem("booking_options", JSON.stringify(this.selectedService.booking_options));
            localStorage.setItem("providerEmail", JSON.stringify(this.$store.getters.providerEmail));
            localStorage.setItem("businessName", JSON.stringify(this.$store.getters.businessName));
            localStorage.setItem("locationName", JSON.stringify(this.$store.getters.locationName));
            
            this.bookingData.from = moment(this.selectedSlot); 
            localStorage.setItem("appointmentDate", JSON.stringify(this.selectedSlot));
            this.bookingData.to = moment(this.selectedSlot).add(this.selectedService.duration, "m");

            this.bookingData.provider.first_name = this.$store.getters.providerFirstName;
            this.bookingData.provider.last_name = this.$store.getters.providerLastName; 
            this.bookingData.provider.unique_id = this.$store.getters.providerId;
            this.bookingData.provider.color_code = this.$store.getters.providerColorCode; 
            
            this.bookingData.facility.location_name = this.$store.getters.locationName; 
            this.bookingData.facility.unique_id = this.$store.getters.locationId;
                
            this.bookingData.service_details.name = this.selectedService.name;
            this.bookingData.service_details.code = ""; // Why is this field there? Is it required? 
            this.bookingData.service_details.duration = this.selectedService.duration;
            this.bookingData.service_details.pre_service_buffer_time = this.selectedService.pre_service_buffer_time;
            this.bookingData.service_details.post_service_buffer_time = this.selectedService.post_service_buffer_time;
            this.bookingData.service_details.unique_id = this.selectedService.id;

            //console.log(JSON.stringify(this.bookingData));
            this.tempAppointmentId = this.guid();
            //console.log('this.tempAppointmentId = ' + this.tempAppointmentId);
            localStorage.setItem(this.tempAppointmentId, JSON.stringify(this.bookingData));

            // Go to the next page (based on pay-now or pay-later)
            if(pay_now == 0 || this.selectedService.service_cost <= 0)
            {
                this.loadingData = true;
                this.loadingData = false;
                this.$router.push('/booking-confirmation/?aid='+this.tempAppointmentId);
            }
            else
            {
                this.selectedPayGateway=this.paymentconfigobj?this.paymentconfigobj:null;
                this.selectedPayGatewayName = this.selectedPayGateway && this.selectedPayGateway.name?this.selectedPayGateway.name:null;
                this.selectedPayGatewayId = this.selectedPayGateway && this.selectedPayGateway.gw_id?this.selectedPayGateway.gw_id:null;
                if(!this.selectedPayGatewayName){
                    //----ARISTA----
                    this.loadingData = true;
                    if(this.$store.getters.tenantId==="05c7079f-d889-4a40-8fac-0ae75c445c15")
                    {
                        this.showpaybutton=false;
                        let encryption_url = process.env.VUE_APP_FRONTEND_API_BASE+'/api/ccavRequestHandler';
                        let order_id = Date.now();
                        let merchant_param1 = this.tempAppointmentId; 
                        let merchant_param3 = 'https'+ '-COLON-' + window.location.hostname; //'arista.genamet.com';
                        let merchant_id = 145627;
                        let merchant_id_intl = 'M_Bumble95_12857';
                        let currency = this.$store.getters.locationCurrency; // 'INR';
                        let amount = this.selectedService.service_cost;  //cost
                        let amount_usd = this.selectedService.service_cost_usd;  //cost
                        let amount_type = this.selectedService.cost_type;  //cost_type
                        let redirect_url=process.env.VUE_APP_FRONTEND_API_BASE+"/api/ccavResponseHandler"
                        let redirect_url_intl=process.env.VUE_APP_FRONTEND_API_BASE+"/api/ccavResponseHandlerIntl"
                        //console.log("CURRENCY: "+ currency);
                        let cancel_url="https://" + window.location.hostname + "/payment/cancel/";
                        let language =  'en';
                        let payment_url = 'http://doctorswati.com/ccavenue-redirect/';
                        let payment_url_intl = 'http://doctorswati.com/ccavenue-redirect-intl/';
                        if(this.browser_country != 'IN'){
                            amount = (this.selectedService.service_cost_usd)*(this.exchangeRate); 
                            amount = amount.toFixed(2);
                        }

                        axios.get(encryption_url, 
                            {
                                params: {
                                    'merchant_id': merchant_id,
                                    'order_id': order_id,
                                    'currency': currency,
                                    'amount': amount,
                                    'redirect_url': redirect_url,
                                    'cancel_url': cancel_url,
                                    'language': language,
                                    'merchant_param1': merchant_param1,
                                    'merchant_param3': merchant_param3,
                                    'c': 'IN'
                                },
                                headers: {
                                    'Content-Type': 'application/json',
                                    'x_tenant_id': this.$store.getters.tenantId
                                }
                            }
                        ).then(response1 =>{
                            this.loadingData = false;
                            //console.log('enc url responded');
                            let access_code=response1.data.xscode; 
                            let encRequest=response1.data.encReq;
                            //console.log(encRequest + '|||' + access_code);
                            //console.log(payment_url + '?encRequest='+encRequest+'&access_code='+access_code);
                            window.location.href = payment_url + '?encRequest='+encRequest+'&access_code='+access_code;
                        }).catch(e => {
                            //console.log('error in enc call');
                            this.loadingData = false;
                            //console.log(e);
                            this.$router.push('/payment/error/');
                        })
                        // End - Encrypt the request                            
                    }
                    if(this.$store.getters.tenantId==="1e8f7691-dbae-436e-9ab3-4151d93ab64e"){
                        this.showpaybutton=false;
                  var config = {
                method: 'get',
                //url: this.posturl+"payment/stripe?serviceid="+this.selectedServiceId+"&aid="+this.tempAppointmentId+"&orderid="+Date.now(),
                url: "http://localhost:49600/api/v1/payment/stripe?serviceid="+this.selectedServiceId+"&aid="+this.tempAppointmentId+"&orderid="+Date.now(),
                headers: { 
                    'Content-Type': 'application/json',
                    'x_tenant_id': this.$store.getters.tenantId,
                    'route_entity_name':'/tenant'
                }
            };
               axios(config).then(response => {
                    
                    if(response.statusCode == 500 || response.statusCode == 400){
                         this.loadingData = false;
                             this.$router.push('/payment/error/');
                                                   
                    }else{
                         this.loadingData = false;
                         debugger;
                         window.location.href = response.data.result;
                    }                
                })
                .catch(error => {
                    console.log('Error in the book appt api call');
                    console.log(error);
                     this.loadingData = false;
                      this.$router.push('/payment/error/');
                })
                    }
                }
                else if (this.selectedPayGatewayName=="Razorpay")
                {
                    this.createOrder();
                }
            }
            // End - go to next page
        },
        createOrder()
        {
            this.loadingData = true;
            var payloaddata = {
                "sid":this.bookingData.service_details.unique_id,
                "lid":this.bookingData.facility.unique_id,
                "stid":this.$store.getters.providerId,
                "paygwid":this.selectedPayGatewayId
            }
            var config = {
                method: 'POST',
                url: this.posturl+"payment/createorder",
                headers: { 
                    'Content-Type': 'application/json',
                    'x_tenant_id': this.$store.getters.tenantId,
                    'route_entity_name':'/payment'
                },
                data:payloaddata
            };
            var self = this;
            axios(config)
            .then(function (response) {
                if(response && response.data){
                    console.log("ORDER RESPONSE>>>>",response);
                    self.raz_api_key=response.data.raz_api_key;
                    self.raz_amount=response.data.amount;
                    self.raz_curncy=response.data.currency;
                    self.raz_order_id=response.data.id;
                    self.raz_order_desc="RazorPay - Appointment With Dr "+self.bookingData.provider.first_name+" On "+moment(self.bookingData.from, moment.ISO_8601).format("DD/MM/YYYY")+" At "+moment(self.bookingData.from, moment.ISO_8601).format("hh:mm:ss A");
                    self.raz_customer_name=self.bookingData.patient_details.name;
                    self.raz_customer_email =self.bookingData.patient_details.email;
                    self.raz_customer_mobile = self.bookingData.patient_details.mobile;
                    //Build the Razor Pay Script
                    //self.posturl = self.posturl+"payment/createorder";
                    //localStorage.setItem("tempaid",self.tempAppointmentId);
                    //localStorage.setItem("raz_order_id",self.raz_order_id);
                    //localStorage.setItem("raz_order_id",self.raz_order_id);
                    self.loadingData = false;

                    // //SHOW PAY BUTTON
                    // self.showpaybutton=true;
                    //debugger
                    var options = {
                        "key": self.raz_api_key,
                        "amount": self.raz_amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
                        "currency": self.raz_curncy,
                        "name": localStorage.businessName.replace(/^\"+|\"+$/g, ''),
                        "description": self.raz_order_desc,
                        "image": localStorage.businesslogourl,
                        "order_id": self.raz_order_id,
                        //"callback_url":self.posturl+"payment/internetbankingcallbackapi?tid="+self.$store.getters.tenantId,
                        //"redirect": true,
                        "handler": function (response){
                            // alert(response.razorpay_payment_id);
                            // alert(response.razorpay_order_id);
                            // alert(response.razorpay_signature);
                            self.loadingData = true;
                            var paymentcapturedata = {
                                "razorpay_payment_id":response.razorpay_payment_id,
                                "razorpay_order_id":response.razorpay_order_id,
                                "razorpay_signature":response.razorpay_signature,
                                "paygwid":self.selectedPayGatewayId,
                                "stid":self.$store.getters.providerId,
                                "HMAC_orderid":self.raz_order_id,
                                "appointment_id_temp":self.tempAppointmentId,
                                "back_to_host": 'https'+ '-COLON-' + window.location.hostname, //'arista.genamet.com';
                                "date_created":moment().format("YYYY-MM-DD HH:mm:ss")
                            }
                            var paymentcapturedataconfig = {
                                method: 'POST',
                                url: self.posturl+"payment/capturepayment",
                                headers: {
                                    'Content-Type': 'application/json',
                                    'x_tenant_id': self.$store.getters.tenantId,
                                    'route_entity_name':'/payment',
                                },
                                data:paymentcapturedata
                            };
                            axios(paymentcapturedataconfig)
                            .then(function (response) {
                                console.log("PAYMENT CAPTURE DATA>>> ",response);
                                if(localStorage.pmntcptrddata){
                                    localStorage.removeItem("pmntcptrddata");
                                }
                                if(response && response.data && response.data.result){
                                    localStorage.setItem("pmntcptrddata",JSON.stringify(response.data.result));
                                    self.loadingData = false;
                                    self.redirectToAppCnfpage();
                                }
                            })
                            .catch(err=>{
                                console.error(err);
                                self.showpaybutton=true;
                            });
                        },
                        "prefill": {
                            "name": self.raz_customer_name,
                            "email": self.raz_customer_email,
                            "contact": self.raz_customer_mobile
                        },
                        "notes": {
                            "desc": self.raz_order_desc,
                            "tenantid": self.$store.getters.tenantId,
                            "emailsubject": "Payment Successful - Dr "+self.bookingData.provider.first_name,
                            "serviceid":self.selectedService.id,
                            "patientemail":self.bookingData.customer_details.email,
                            "patientmobile":self.bookingData.customer_details.mobile,
                            "patientname":self.bookingData.customer_details.name,
                            "doctorid":self.bookingData.provider.unique_id,
                            "bookingwebsiteguid":"AC3D6FC4-4F8B-41E4-BA8F-B4344DCB9650"
                        },
                        "theme": {
                            "color": self.staffcolor
                        }
                    };
                    self.rzp1 = new Razorpay(options);
                    if(document.getElementById('rzp-button1') && self.showpaybutton){
                        if(self.showpaybutton && self.rzp1){
                            self.rzp1.open();
                            e.preventDefault();
                        }
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
            });

        },
        redirectToAppCnfpage(){
            this.loadingData = true;
            this.loadingData = false;
            var razorPayResponse=null;
            if(localStorage.pmntcptrddata)
            {
                razorPayResponse = JSON.parse(localStorage.pmntcptrddata);
                //razorPayResponse.status=razorPayResponse.status==="captured"?"Success":"";
            }
            this.$router.push('/booking-confirmation/?order_id='+razorPayResponse.order_id+'&tracking_id='+razorPayResponse.id+'&order_status='+razorPayResponse.status+'&merchant_param1='+this.tempAppointmentId);
        },
        onRazorPayBtnClick(pay_now){
            this.bookNow(pay_now);
        }
    },
    updated(){
        // if(document.getElementById('rzp-button1') && this.showpaybutton){
        //     var self = this;
        //     if(self.showpaybutton && self.rzp1){
        //         document.getElementById('rzp-button1').onclick = function(e){
        //             self.rzp1.open();
        //             e.preventDefault();
        //         }
        //     }
        // }
    }
}
</script>

<style scoped>
.input-group>.custom-select:not(:last-child),
.input-group>.form-control:not(:last-child) {
    border-top-right-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
}
.display-daytime-hold .pull-calender-right{float:right; padding:0 0 0 10px; color:#bec2c3;}
input.date.select_validate.flatpickr-input.form-control.input{
    text-align: left !important;
    background-color: white !important;
    border: 0px;
}
input.form-control.date.select_validate.flatpickr-input.input.active{
    text-align: left !important;
    background-color: white !important;
    border: 0px;
}
/* Razor Pay button */
.razorpay-payment-button{}


.date-icon.in-form {
    top: 11px;
    right: 0;
    left: 115px;
    z-index: 1;
}
.display-daytime-hold.pull-right {
    width: 420px;
}
input.date.select_validate.form-control.input{
    padding-left: 20px !important;
    cursor: pointer !important;
}
span.pull-calender-right.date-icon-holder {
    display: flex;
}
p.selectDate {
    display: block;
    min-width: 100px;
    padding-top: 8px;
    color: initial;
}
.termsColor {
  color: #0056e0;
}
</style>
